import { PlessHttp } from './../../../shared/http/pless-http.service';
import { Component, ViewEncapsulation, OnInit, ViewChild, ViewContainerRef, ElementRef, ComponentRef, HostListener } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW1300Model } from './kymw1300.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessDialogMultiMessageServiceSub } from '../../../commons/kymw00/pless-dialog-multi-message-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { SellAreaCodeComboBoxComponent } from '../../../commons/kymw02/combo-box/sell-area-code-combo-box/sell-area-code-combo-box.component';
import { KYMW0902Component } from '../../../commons/kymw09/kymw0902/kymw0902.component';
import { KYMW1301Component } from '../kymw1301/kymw1301.component';
import { KYMW1302Component } from '../kymw1302/kymw1302.component';
import { KYMW1304Component } from '../kymw1304/kymw1304.component';
import { KYMW1311Component } from '../kymw1311/kymw1311.component';
import { KYMW1312Component } from '../kymw1312/kymw1312.component';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { FMenu } from 'src/app/commons/kymw02/function-menu/fmenu';
import { GetCatalogInfoService } from './api-services/get-catalog-info.service';
import { OutputSetPlanListService } from './api-services/output-set-plan-list.service';
import { FileDownloadConfirmService } from '../../../commons/kymw02/file-download-confirm/file-download-confirm.service';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { OutputBundleMixMatchListService } from './api-services/output-bundle-mix-match-list.service';
import { GetPlanNumListService } from './api-services/get-plan-num-list.service';
import { CheckRegistPlanService } from './api-services/check-regist-plan.service';
import { KYMW1304OutputModel } from '../kymw1304/vo/kymw1304-output.model';
import { KYMW1300SelectedListComponent } from './kymw1300-selected-list/kymw1300-selected-list.component';
import { KYMW1300TargetListComponent } from './kymw1300-target-list/kymw1300-target-list.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';
import { KYMW1300GetPlanNumListModel } from './vo/kymw1300-get-plan-num-list.model';
import { KYMW1300GetSearchSelectedListModel } from './vo/kymw1300-get-search-selected-list.model';
import { GetSelectedListService } from './api-services/get-selected-list.service';
import { KYMW0800Component } from '../../../commons/kymw08/kymw0800/kymw0800.component';
import { KYMW0800InputModel } from '../../../commons/kymw08/kymw0800/vo/kymw0800-input.model';
import { KYMW0800OutputModel } from '../../../commons/kymw08/kymw0800/vo/kymw0800-output.model';
import { KYMW1312InputModel } from '../kymw1312/vo/kymw1312-input.model';
import { KYMW1308Component } from '../kymw1308/kymw1308.component';
import { KYMW1308InputModel } from '../kymw1308/vo/kymw1308-input.model';
import { KYMW1307InputModel } from '../kymw1307/vo/kymw1307-input.model';
import { KYMW1307Component } from '../kymw1307/kymw1307.component';
import { KYMW1310Component } from '../kymw1310/kymw1310.component';
import { KYMW0D00Component } from '../../../commons/kymw0d/kymw0d00/kymw0d00.component';
import { KYMW0D00InputModel } from '../../../commons/kymw0d/kymw0d00/vo/kymw0d00-input.model';
import { KYMW1300RegistPlanModel } from './vo/kymw1300-regist-plan.model';
import { KYMW1300CheckRegistPlanModel } from './vo/kymw1300-check-regist-plan.model';
import { RegistPlanService } from './api-services/regist-plan.service';
import { PlessAlert } from '../../../shared/pless-alert/pless-alert.component';
import { KYMW0D00DataDiv } from '../../../commons/kymw0d/kymw0d00/kymw0d00.model';
import { KYMW1300DeletePlanModel } from './vo/kymw1300-delete-plan.model';
import { DeletePlanService } from './api-services/delete-plan.service';
import { KYMW0500OutputModel } from '../../../commons/kymw05/kymw0500/vo/kymw0500-output.model';
import { KYMW0300OutputModel } from '../../../commons/kymw03/kymw0300/vo/kymw0300-output.model';
import { GetPlanTargetListService } from './api-services/get-plan-target-list.service';
import { KYMW0400OutputModel } from '../../../commons/kymw04/kymw0400/vo/kymw0400-output.model';
import { KYMW1308OutputModel } from '../kymw1308/vo/kymw1308-output.model';
import { KYMW0900OutputModel } from '../../../commons/kymw09/kymw0900/vo/kymw0900-output.model';
import { KYMW1310InputModel } from '../kymw1310/vo/kymw1310-input.model';
import { KYMW1312OutputModel } from '../kymw1312/vo/kymw1312-output.model';
import { KYMW0900InputModel } from '../../../commons/kymw09/kymw0900/vo/kymw0900-input.model';
import { KYMW0900Component } from '../../../commons/kymw09/kymw0900/kymw0900.component';
import { PlanGoodsLockService } from '../../../commons/kymw00/api-services/plan-goods-lock.service';
import { FileUploadService, FileAccept } from '../../../commons/kymw02/file-upload/file-upload.service';
import { UploadPlanGoodsCoopFileService } from './api-services/upload-plan-goods-coop-file-service';
import { UploadCoopFileService } from './api-services/upload-coop-file-service';
import { KYMW1317Component } from '../kymw1317/kymw1317.component';
import { KYMW1317InputModel } from '../kymw1317/vo/kymw1317-input.model';
import { KYMW1317OutputModel } from '../kymw1317/vo/kymw1317-output.model';
import { CommonTargetModel } from './vo/common-target.model';
import { CatalogInfoModel } from './vo/catalog-info.model';
import { PlanNumModel } from './vo/plan-num.model';
import { SelectedGoodsListModel } from './vo/selected-goods.model';
import { FunctionMenuService } from 'src/app/commons/kymw02/function-menu/function-menu.service';
import { CanDeactivateType } from 'src/app/shared/utils/leave-confirm.guard';
import { KYMW2000InputModel } from '../../kymw20/kymw2000/vo/kymw2000-input.model';
import { KYMW2000Component } from '../../kymw20/kymw2000/kymw2000.component';
import { GetBundleCatalogRoundInfoListService } from './api-services/get-bundle-catalog-round-info-list.service';
import { UploadProposalCarrotFileService } from './api-services/upload-proposal-carrot-file.service';
import { GetFeatureCodeListService } from './api-services/get-feature-code-list.service';
import { GetPlanGoodsMediumtService } from './api-services/get-plan-goods-medium.service';
import { KYMW1300GetPlanTargetListModel } from './vo/kymw1300-get-plan-target-list.model';
import { PlanTargetList } from './vo/plan-target-list.model';
import { KYMW1318Component } from '../kymw1318/kymw1318.component';
import { KYMW1318InputModel } from '../kymw1318/vo/kymw1318-input.model';
import { Subject } from 'rxjs';
import { GetDeletePlanGoodsInfoModel } from '../kymw1318/vo/kymw1318-get-delete-plan-goods-info.model';
import { GetDeletePlanGoodsInfoService } from '../kymw1318/api-services/get-delete-plan-goods-info';
import { KYMW1320Component } from '../kymw1320/kymw1320.component';
import { KYMW1321Component } from '../kymw1321/kymw1321.component';

/**
 * 商品企画マスタ画面を管理するクラス
 *
 * @export KYMW1300Component
 * @class KYMW1300Component
 */
@Component({
  selector: 'app-kymw1300',
  templateUrl: 'kymw1300.component.html',
  styleUrls: ['kymw1300.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    {
      provide: PlanGoodsLockService,
      useFactory: (plessHttp: PlessHttp, dialogService: PlessDialogServiceSub) => new PlanGoodsLockService(plessHttp, dialogService),
      deps: [PlessHttp, PlessDialogServiceSub]
    }
  ],
})
export class KYMW1300Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw1300Model: KYMW1300Model = new KYMW1300Model();

  // 画面部品参照
  @ViewChild('kymw1300_02', { static: true }) public kymw1300_02: KYMW1300TargetListComponent = null;
  @ViewChild('kymw1300_03', { static: true }) public kymw1300_03: KYMW1300SelectedListComponent = null;

  @ViewChild('txt_OrderCode', { static: true }) txt_OrderCode: OrderCodeTextInputComponent;
  @ViewChild('lbl_DelivCatalogId', { static: true }) lbl_DelivCatalogId: ElementRef;
  @ViewChild('cmb_MediumType', { static: true }) public cmb_MediumType: ElementRef;
  @ViewChild('cmb_SellArea', { static: true }) cmb_SellArea: SellAreaCodeComboBoxComponent;
  @ViewChild('icnEditLock', { static: true }) icnEditLock: ElementRef;
  @ViewChild('cmb_BundleCatalogGuideStandardName', { static: true }) cmb_BundleCatalogGuideStandardName: ElementRef;
  @ViewChild('dg_SelectedItemList', { static: true }) dg_SelectedItemList: FlexGrid;

  // サブ画面参照
  public kymw0800ComponentRef: ComponentRef<any> = null;
  public kymw0800cmp: KYMW0800Component = null;                                 // 実績履歴画面コンポーネント
  public kymw1307ComponentRef: ComponentRef<any> = null;
  public kymw1307cmp: KYMW1307Component = null;                                 // 予算・計画・実績表画面コンポーネント
  public kymw1308ComponentRef: ComponentRef<any> = null;
  public kymw1308cmp: KYMW1308Component = null;                                 // バンドルミックスマッチ設定画面コンポーネント
  public kymw1310ComponentRef: ComponentRef<any> = null;
  public kymw1310cmp: KYMW1310Component = null;                                 // Ｗ掲載設定画面コンポーネント
  public kymw1312ComponentRef: ComponentRef<any> = null;
  public kymw1312cmp: KYMW1312Component = null;                                 // セット企画画面コンポーネント
  public kymw1318ComponentRef: ComponentRef<any> = null;
  public kymw1318cmp: KYMW1318Component = null;                                 // 受注コード指定選定解除モーダル画面コンポーネント

  public readonly BUTTON_STYLE_DEFAULT: string = String('default');
  public readonly BUTTON_STYLE_SELECTED: string = String('selected');
  public selectElement: any = <any>'';

  // ボタンスタイル初期値
  public clsLock = this.BUTTON_STYLE_DEFAULT;

  // 編集ロック・ツールチップ表示位置
  public styleToolTipLeftEditLock = Number(20);
  // 表示切替・ツールチップ表示位置
  public styleToolTipLeftDispChange = Number(-40);

  /**
   * ウィンドウ内のクリック・右クリック時にイベントを追加
   *
   * @param {*} event
   * @memberof KYMW1300Component
   */
  @HostListener('click', ['$event'])
  @HostListener('contextmenu', ['$event'])
  private onClickOut(event: Event): void {
    // モードレスのコンテキストメニューを非表示
    if (this.kymw0800cmp !== null) {
      this.kymw0800cmp.contextMenu.hide();
    }
  }

  /**
   * Creates an instance of KYMW1300Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {ViewContainerRef} viewContainerRef
   * @param {FileDownloadConfirmService} fileDownloadConfirmService
   * @param {CheckRegistPlanService} checkRegistPlanService
   * @param {RegistPlanService} registPlanService
   * @param {DeletePlanService} deletePlanService
   * @param {GetOrderTargetListService} getOrderTargetListService
   * @param {GetPlanTargetListService} getPlanTargetListService
   * @param {GetSearchTargetListService} getSearchTargetListService
   * @param {GetCatalogInfoService} getCatalogInfoService
   * @param {GetPlanNumListService} getPlanNumListService
   * @param {GetSelectedListService} getSelectedListService
   * @param {OutputBundleMixMatchListService} outputBundleMixMatchListService
   * @param {OutputSetPlanListService} outputSetPlanListService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @param {PlanGoodsLockService} planGoodsLockServiceSub
   * @memberof KYMW1300Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private dialogMMService: PlessDialogMultiMessageServiceSub,
    public viewContainerRef: ViewContainerRef,
    private fileDownloadConfirmService: FileDownloadConfirmService,

    private checkRegistPlanService: CheckRegistPlanService,
    private registPlanService: RegistPlanService,

    private deletePlanService: DeletePlanService,
    private getPlanTargetListService: GetPlanTargetListService,

    private getCatalogInfoService: GetCatalogInfoService,
    private getPlanNumListService: GetPlanNumListService,
    private getSelectedListService: GetSelectedListService,
    private outputBundleMixMatchListService: OutputBundleMixMatchListService,
    private outputSetPlanListService: OutputSetPlanListService,
    public kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private planGoodsLockServiceSub: PlanGoodsLockService,
    private fileUploadService: FileUploadService,
    private uploadPlanGoodsCoopFileService: UploadPlanGoodsCoopFileService,
    private uploadCoopFileService: UploadCoopFileService,
    private uploadProposalCarrotFileService: UploadProposalCarrotFileService,
    private getBundleCatalogRoundInfoListService: GetBundleCatalogRoundInfoListService,
    private getFeatureCodeListService: GetFeatureCodeListService,
    private getPlanGoodsMediumtService: GetPlanGoodsMediumtService,
    private plessHttp: PlessHttp,
    private fmenuService: FunctionMenuService,
    private getDeletePlanGoodsInfoService: GetDeletePlanGoodsInfoService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW1300Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW1300';
    this.planGoodsLockService = this.planGoodsLockServiceSub;

    // メニュー初期設定
    this.initMenuBar();

    this.kymw1300Model.kymw1300Component = this;

    // 活性・非活性制御
    // 「編集ロック」を"閲覧モード"にする。
    this.setEditLock(false);
    this.setLockButtonStyle(false);

    // 24. 媒体一覧取得API呼び出し
    this.getPlanGoodsMediumtService.execute(this.kymw1300Model);
  }

  /**
   * メニュー初期設定
   *
   * @private
   * @memberof KYMW1300Component
   */
  private initMenuBar(): void {
    // ［ファイル］メニューを作成
    const menuFile = new FMenu('#menuFile', {
      header: 'ファイル',
      displayMemberPath: 'header',
      subItemsPath: 'items',
      selectedValuePath: 'menuID',
      dropDownCssClass: 'menubar-items',
      openOnHover: false,
      isAnimated: true,
      itemsSource: [
        { header: '企画書<br/>データ出力', menuID: 'mi_KYMW1301' },
        { header: '1物N価取扱期間<br/>一覧表', menuID: 'mi_KYMW1321' },
        { header: 'プロモ<br/>商品企画点検リスト', menuID: 'mi_KYMW1320' },
        { header: 'バンドルミックス<br/>マッチリスト出力', menuID: 'mi_OutputBundleMixMatchList' },
        { header: 'セット企画<br/>リスト出力', menuID: 'mi_OutputSetPlanList' },
        { header: '業態別企画書<br/>データ出力', menuID: 'mi_KYMW1311' },
        { header: '企画メンテ<br/>CSVファイル取込', menuID: 'mi_UploadPlanGoodCopeFile' },
        { header: '取扱生協<br/>CSVファイル取込', menuID: 'mi_UploadCoopFile' },
        { header: '企画書<br/>データ（キャロット）取込', menuID: 'mi_UploadProposalCarrotFile' },
      ],
      command: this.getFormatMenuCommand(),
      // イベント設定
      itemClicked: () => {
        this.eventMenu_CLICKHandler(menuFile);
      }
    });

    // ［編集］メニューを作成
    const menuEdit = new FMenu('#menuEdit', {
      header: '編集',
      displayMemberPath: 'header',
      subItemsPath: 'items',
      selectedValuePath: 'menuID',
      dropDownCssClass: 'menubar-items',
      openOnHover: false,
      isAnimated: true,
      itemsSource: [
        { header: 'Pコード一発選定', menuID: 'mi_KYMW1304' },
        { header: '業態別企画設定', menuID: 'mi_KYMW0902' },
        { header: '選定済商品数一覧', menuID: 'mi_KYMW2000' },
        { header: 'セット企画設定', menuID: 'mi_KYMW1312' },
      ],
      command: this.getFormatMenuCommand(),
      // イベント設定
      itemClicked: () => {
        this.eventMenu_CLICKHandler(menuEdit);
      }
    });

    this.fmenuService.menus = [menuFile, menuEdit];
  }

  /**
   * メニューアイテム活性・非活性制御
   *
   * @private
   * @returns {*}
   * @memberof KYMW1300Component
   */
  private getFormatMenuCommand(): any {
    return {
      canExecuteCommand: (param) => {
        // 各項目の活性制御
        switch (param.menuID) {
          case 'mi_KYMW1304':                                                   // 「Pコード一発選定」の場合
            return this.setEnabledKYMW1304();
          case 'mi_KYMW1312':                                                   // 「セット企画設定」の場合
          case 'mi_OutputSetPlanList':                                          // 「セット企画リスト出力」の場合
            return this.setEnabledSetPlanMenu();
          case 'mi_UploadPlanGoodCopeFile':                                     // 「企画メンテCSVファイル取込」の場合
          case 'mi_UploadCoopFile':                                             // 「取扱生協CSVファイル取込」の場合
          case 'mi_UploadProposalCarrotFile':                                   // 「企画書<br/>データ（キャロット）取込」の場合
            // 権限のチェック
            if (this.getFuncPermission() === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {  // 「2：フルコントロール可能」の場合
              return true;
            } else {                                                            // 上記以外の場合
              return false;
            }
          default:
            return true;
        }
      }
    };
  }

  /**
   * メインメニュー_クリック時に呼び出される
   *
   * @param {Menu} menu
   * @returns {void}
   * @memberof KYMW1300Component
   */
  public eventMenu_CLICKHandler(menu: FMenu): void {

    switch (menu.selectedItem.menuID) {
      case 'mi_KYMW1301':                                                       // 「企画書データ出力」の場合
        // 企画書データ出力画面(モーダル)を表示する。
        const kymw1301Ref = this.dialogService.openModal(KYMW1301Component);
        const kymw1301Instance = kymw1301Ref.componentInstance as KYMW1301Component;
        kymw1301Instance.parent = this;
        kymw1301Instance.closeFunction = () => {
          kymw1301Ref.close();
        };
        break;

      case 'mi_OutputBundleMixMatchList':                                       // 「バンドルミックスマッチリスト出力」の場合
        // ヘッダー情報入力チェック(媒体：チェック要、売り場：チェック否)
        if (!this.checkInputHeader(true, false)) {                                         // チェックエラーの場合
          return;
        }

        // 16. バンドルミックスマッチリスト出力APIリクエストVO初期化処理
        const voBundleMixMatchList = {
          orderCode: this.kymw1300Model.orderCode,
          mediumType: this.kymw1300Model.mediumType,
        };
        //受注コードが未入力の場合、束ね企画の開始受注コードをリクエストパラメータの受注コードにセット
        if (PlessViewUtilsSub.isEmpty(voBundleMixMatchList.orderCode)) {
          voBundleMixMatchList.orderCode = this.kymw1300Model.startOrderCode;
        }
        // 16. バンドルミックスマッチリスト出力API呼び出し
        this.outputBundleMixMatchListService.execute(this.kymw1300Model, voBundleMixMatchList,
          (data: any) => this.outputBundleMixMatchListServiceSuccessFunc(data));

        break;

      case 'mi_OutputSetPlanList':                                              // 「セット企画リスト出力」の場合
        // ヘッダー情報入力チェック(媒体：チェック否、売り場：チェック否)
        if (!this.checkInputHeader()) {                                         // チェックエラーの場合
          return;
        }

        // 19. セット企画リスト出力APIリクエストVO初期化処理
        const voSetPlanList = {
          orderCode: this.kymw1300Model.orderCode,
        };
        //受注コードが未入力の場合、束ね企画の開始受注コードをリクエストパラメータの受注コードにセット
        if (PlessViewUtilsSub.isEmpty(voSetPlanList.orderCode)) {
          voSetPlanList.orderCode = this.kymw1300Model.startOrderCode;
        }
        // 19. セット企画リスト出力API呼び出し
        this.outputSetPlanListService.execute(this.kymw1300Model, voSetPlanList,
          (data: any) => this.outputSetPlanListServiceSuccessFunc(data));

        break;

      case 'mi_KYMW1311':                                                       // 「業態別企画書データ出力」の場合
        // 業態別企画書データ出力画面(モーダル)を表示する。
        const kymw1311Ref = this.dialogService.openModal(KYMW1311Component);
        const kymw1311Instance = kymw1311Ref.componentInstance as KYMW1311Component;
        kymw1311Instance.parent = this;
        kymw1311Instance.closeFunction = () => {
          kymw1311Ref.close();
        };
        break;

      case 'mi_UploadPlanGoodCopeFile':                                         // 「企画メンテCSVファイル取込」の場合
        // 企画メンテCSVファイルのアップロード選択ダイアログを表示する。
        this.fileUploadService.upload((selectedFiles: File[]) => {
          // 選択ファイルの拡張子を取得
          const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);

          // 拡張子のチェック
          if (extension !== 'csv') {
            this.dialogService.openAlertGetMessage('E0113', ['ファイル種類']);
          } else {
            // 18. 企画メンテCSVファイル取込API呼び出し
            this.uploadPlanGoodsCoopFileService.execute(this.kymw1300Model, selectedFiles[0],
              (data: any) => this.uploadPlanGoodsCoopFileServiceSuccessFunc(data));
          }
        }, [FileAccept.CSV]);
        break;

      case 'mi_UploadCoopFile':                                                 // 「取扱生協CSVファイル取込」の場合
        // 取扱生協CSVファイルのアップロード選択ダイアログを表示する。
        this.fileUploadService.upload((selectedFiles: File[]) => {
          // 選択ファイルの拡張子を取得
          const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);

          // 拡張子のチェック
          if (extension !== 'csv') {
            this.dialogService.openAlertGetMessage('E0113', ['ファイル種類']);
          } else {
            // 20. 取扱生協CSVファイル取込API呼び出し
            this.uploadCoopFileService.execute(this.kymw1300Model, selectedFiles[0],
              (data: any) => this.uploadCoopFileServiceSuccessFunc(data));
          }
        }, [FileAccept.CSV]);
        break;

      case 'mi_UploadProposalCarrotFile':                                                 // 「企画書データ（キャロット）取込」の場合
        // 企画書シート（キャロット）のアップロード選択ダイアログを表示する。
        this.fileUploadService.upload((selectedFiles: File[]) => {
          // 選択ファイルの拡張子を取得
          const extension = PlessViewUtilsSub.getExtension(selectedFiles[0].name);

          // 拡張子のチェック
          if (extension !== 'csv') {
            this.dialogService.openAlertGetMessage('E0113', ['ファイル種類']);
          } else {
            // 21. 企画書シート（キャロット）取込API呼び出し
            this.uploadProposalCarrotFileService.execute(this.kymw1300Model, selectedFiles[0],
              (data: any) => this.uploadProposalCarrotFileServiceSuccessFunc(data));
          }
        }, [FileAccept.CSV]);
        break;

      case 'mi_KYMW1304':                                                       // 「Pコード一発選定」の場合
        // Ｐコード一発選定画面(モーダル)を表示する。
        const kymw1304Ref = this.dialogService.openModal(KYMW1304Component);
        const kymw1304Instance = kymw1304Ref.componentInstance as KYMW1304Component;
        kymw1304Instance.parent = this;
        kymw1304Instance.setKYMW1304Parameter =
          (kymw1304OutputVO: KYMW1304OutputModel) => {
            if (!this.setKYMW1304Parameter(kymw1304OutputVO)) {
              return;
            }
          }

        kymw1304Instance.closeFunction = () => {
          kymw1304Ref.close();
        };
        break;

      case 'mi_KYMW0902':                                                       // 「業態別企画設定」の場合
        // 業態別企画設定画面(モーダル)を表示する。
        const kymw0902Ref = this.dialogService.openModal(KYMW0902Component);
        const kymw0902Instance = kymw0902Ref.componentInstance as KYMW0902Component;
        kymw0902Instance.parent = this;
        kymw0902Instance.closeFunction = () => {
          kymw0902Ref.close();
        };
        break;

      case 'mi_KYMW2000':                                                       // 「注文コード割当確認」の場合
        const kymw2000InputVO: KYMW2000InputModel = {
          funcID: '',
          mediumType: '',
          orderCode: ''
        };

        //受注コードが入力済み
        if ((!PlessViewUtilsSub.isEmpty(this.kymw1300Model.orderCode))) {
          kymw2000InputVO.orderCode = this.kymw1300Model.orderCode;
        }
        //受注コードが未入力かつ、束ね企画媒体が選択されている
        if ((PlessViewUtilsSub.isEmpty(this.kymw1300Model.orderCode)) && (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.bundleCatalogGuideStandardName))) {
          kymw2000InputVO.orderCode = this.kymw1300Model.startOrderCode;
        }
        kymw2000InputVO.funcID = 'KYMW1300';
        kymw2000InputVO.mediumType = this.kymw1300Model.mediumType;
        // 選定済商品数一覧画面(モーダル)を表示する。
        const kymw2000Ref = this.dialogService.openModal(KYMW2000Component);
        const kymw2000Instance = kymw2000Ref.componentInstance as KYMW2000Component;
        kymw2000Instance.parent = this;
        kymw2000Instance.setParams(kymw2000InputVO);
        kymw2000Instance.closeFunction = () => {
          kymw2000Ref.close();
        };
        break;

      case 'mi_KYMW1312':                                                       // 「セット企画設定」の場合
        // セット企画設定画面の起動状況のチェック
        if (!this.isOpened('KYMW1312')) {                                       // 未起動の場合
          // セット企画設定画面起動処理
          this.openPromotionSetGoodsMenuClick(PlessAlert.Yes);

          // 処理復帰
          return;
        }

        if (this.kymw1312cmp.editCount > 0) {
          // 確認メッセージ表示(変更内容を破棄)
          this.dialogService.openAlertGetMessage('Q0107', ['セット企画プロモーション情報'],
            (detail: number) => this.openPromotionSetGoodsMenuClick(detail));
        } else {
          // 『セット企画設定』画面を呼び出す
          this.openPromotionSetGoodsMenuClick(PlessAlert.Yes);
        }
        break;

      case 'mi_KYMW1320':
        // プロモ商品企画点検リスト
        const kymw1320Ref = this.dialogService.openModal(KYMW1320Component);
        const kymw1320Instance = kymw1320Ref.componentInstance as KYMW1320Component;
        kymw1320Instance.closeFunction = () => {
          kymw1320Ref.close();
        }
        break;
      case 'mi_KYMW1321':
        // 1物N価買取期間一覧表
        const kymw1321Ref = this.dialogService.openModal(KYMW1321Component);
        const kymw1321Instance = kymw1321Ref.componentInstance as KYMW1321Component;
        kymw1321Instance.closeFunction = () => {
          kymw1321Ref.close();
        }
        break;
      }
  }

  /**
   * 束ね企画開回始受注コードの有効有無を返却する
   *
   * @return boolean:True有効、False無効
   */
  public isValidStartOrderCode(): boolean {
    return !PlessViewUtilsSub.isEmpty(this.kymw1300Model.delivCatalogIdOfStartOrderCode);
  }

  /**
   * 入力された受注コードが束ね企画回の範囲外かどうかを返却する
   *
   */
  public eventOrederCode_FOCUSOUTHandler(): void {

    // 入力された受注コードが束ね企画回の範囲外だった場合
    if (parseInt(this.kymw1300Model.startOrderCode) > parseInt(this.kymw1300Model.orderCode) || parseInt(this.kymw1300Model.orderCode) > parseInt(this.kymw1300Model.endOrderCode)) {
      this.dialogService.openAlertGetMessage('W0060', [], () => { });
      this.kymw1300Model.orderCode = '';
      // 共通コンポーネントに渡す受注コードに束ね企画の開始受注コードを設定
      this.kymw1300Model.componentOrderCode = this.kymw1300Model.startOrderCode;
    }
  }

  /**
   * セット企画設定(メニュー)_クリック時に、セット企画設定画面を呼び出す
   *
   * @param {number} detail
   * @memberof KYMW1300Component
   */
  public openPromotionSetGoodsMenuClick(detail: number): void {
    if (detail === PlessAlert.Yes) {
      const kymw1312InputVO: KYMW1312InputModel = this.kymw1300Model.setKYMW1312InputVO();

      this.kymw1312ComponentRef = this.dialogService.openModelessSub(this, KYMW1312Component,
        this.viewContainerRef, this.kymw1312ComponentRef, kymw1312InputVO, 0, '', true);
      if (this.kymw1312ComponentRef != null) {
        this.kymw1312cmp = this.kymw1312ComponentRef.instance as KYMW1312Component;
        this.kymw1312cmp.setInterfaceParam(kymw1312InputVO);
        this.kymw1312cmp.parent = this;

        // 設定ボタン押下時の処理
        this.kymw1312cmp.setKYMW1312Parameter =
          (kymw1312OutputVO: KYMW1312OutputModel) => this.setKYMW1312Parameter(kymw1312OutputVO);

        // ウィンドウが閉じられる際の処理
        this.kymw1312cmp.closeFunction = () => {
          this.kymw1312ComponentRef.destroy();
          this.kymw1312cmp = null;
        };
      }
    }
  }

  /**
   * 受注コード(テキストインプット)_変更時に呼び出される
   *
   * @memberof KYMW1300Component
   */
  public eventOrderCode_CHANGEHandler(): void {

    // 営業カレンダー・配達企画回の文字数チェック
    // 営業カレンダー・配達企画回が設定されているのであれば、何らかの検索結果が表示されていると判断する
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.delivCatalogId)) {        // 指定ありの場合
      // データグリッド行の選択解除
      this.kymw1300_02.dg_SelectTargetList.select(-1, -1);
      this.kymw1300_03.dg_SelectedItemList.select(-1, -1);
      // 画面のクリア処理を行う
      this.kymw1300Model.clearList();
      this.kymw1300_02.targetSetModel.clearList();
      this.kymw1300_03.selectedModel.clearList();

      this.kymw1300_03.cmb_PageNo.clear();
    }

    // 受注コードの入力チェック
    if (this.txt_OrderCode.isValidOrderCode()) {                                // チェック正常の場合
      // 共通コンポーネントに渡す受注コードに画面の受注コードを設定
      this.kymw1300Model.componentOrderCode = this.kymw1300Model.orderCode;

      // ページ名コンボの再取得
      this.kymw1300_03.cmb_PageNo.reload();

      // 01. 企画管理情報取得APIリクエストVO初期化処理
      const voCatalogInfo = {
        orderCode: this.kymw1300Model.orderCode,
      };

      // 01. 企画管理情報取得API呼び出し
      this.getCatalogInfoService.execute(this.kymw1300Model, voCatalogInfo,
        (data: any) => this.getCatalogInfoServiceSuccessFunc(data, false));

      // セット企画画面の起動状況のチェック
      if (this.isOpened('KYMW1312')) {                                          // 起動済みの場合
        // セット企画設定画面を閉じる
        this.kymw1312cmp.eventClose_CLICKHandler(null);
      }

      this.kymw1300_03.cmb_PageNo.mediumType = this.kymw1300Model.mediumType;
      this.kymw1300_03.cmb_PageNo.orderCode = this.kymw1300Model.componentOrderCode;

      // 媒体が設定済みの場合、特集コード取得
      if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.mediumType)) {
        const getFeatureCodeVO = {
          orderCode: this.kymw1300Model.componentOrderCode,
          mediumType: this.kymw1300Model.mediumType
        }
        this.getFeatureCodeListService.execute(getFeatureCodeVO, (data: any) => this.getFeatureCodeListServiceSuccessFunc(data));
      }

      // 注文コード取得
      this.getOrderNumQuota();
      this.kymw1300_02.cmb_OrderNumQuota.selectedIndex = 0;
    } else {
      // 共通コンポーネントに渡す受注コードに束ね企画の開始受注コードを設定
      this.kymw1300Model.componentOrderCode = this.kymw1300Model.startOrderCode;

      this.kymw1300_03.cmb_PageNo.clear();
      this.kymw1300_03.cmb_PageNo.mediumType = this.kymw1300Model.mediumType;
      this.kymw1300_03.cmb_PageNo.orderCode = this.kymw1300Model.componentOrderCode;
      this.kymw1300_03.selectedModel.clearList();
      this.kymw1300_02.cmb_OrderNumQuota.clear();
      this.kymw1300_03.cmb_OrderNumQuota_Selected.clear();

      this.kymw1300Model.displayBundleCatalogInfo();
    }

    // バンドルミックスマッチボタン活性制御
    this.changeEnableBundleMixMatch();

    // 「編集ロック」を"閲覧モード"にする。
    this.setEditLock(false);
    this.setLockButtonStyle(false);
  }

  /**
   * 媒体(コンボボックス)_変更時に呼び出される
   *
   * @memberof KYMW1300Component
   */
  public eventMediumType_CHANGEHandler(): void {
    if (this.getIcnEditLock()) {
      // 編集モードの場合は閲覧モードにする
      this.setEditLock(false);
      this.setLockButtonStyle(false);
    }
    this.kymw1300Model.clearBundleList();
    this.kymw1300_02.targetSetModel.clearList();
    this.kymw1300_03.selectedModel.clearList();
    // 特集コード割当をクリア
    this.kymw1300Model.featureCode = '';

    const mediumType: string = this.kymw1300Model.mediumType;
    const selectedMediumTypeList = this.kymw1300Model.mediumTypeList.find(item => item.MediumType === this.kymw1300Model.mediumType);
    this.cmb_SellArea.setMediumType(mediumType, '20', null);   // 売り場を20：中面に固定
    this.sellArea_CHANGEDHandler();

    if (this.txt_OrderCode.isValidOrderCode()) {
      // 受注コードが有効
      this.kymw1300Model.componentOrderCode = this.kymw1300Model.orderCode;
    } else {
      this.kymw1300Model.componentOrderCode = this.kymw1300Model.startOrderCode;
    }

    // 選定候補一覧のステータス変更処理
    this.kymw1300_02.targetSetModel.setStatus_Change(mediumType);

    // 選定候補一覧の背景色設定処理
    this.kymw1300_02.setColorPattern(this.kymw1300_02.dg_SelectTargetList);

    if (PlessViewUtilsSub.isEmpty(mediumType)) {
      this.kymw1300_02.cmb_OrderNumQuota.clear();
      this.kymw1300_03.cmb_OrderNumQuota_Selected.clear();
      this.kymw1300Model.orderNumQuotaCode = '';                                                // 注文コードクリア(上2行でクリアできるがコンソールエラー回避のため)
      this.kymw1300Model.radioGroup = '';                                                       // チェック外す
      this.kymw1300Model.enabledBundleCatalogRound = false;                                     // ラジオボタン束ね企画回への選定を非活性
      this.kymw1300Model.enabledSingleBundleCatalogRound = false;                               // ラジオボタン単企画回への選定を非活性
      this.kymw1300Model.kymw1300Component.txt_OrderCode.required = false;                      // 受注コードの背景を白色
      this.kymw1300Model.bundleCatalogRoundInfoList.length = 0;
      this.kymw1300Model.enabledBundleCatalogGuideStandardName = false;
    } else {
      this.getOrderNumQuota();                                                                 // 注文コード取得
      this.kymw1300Model.radioGroup = '2';                                                     // ラジオボタン単企画回への選定にチェック
      this.kymw1300Model.enabledBundleCatalogRound = false;                                    // ラジオボタン束ね企画回への選定を非活性
      this.kymw1300Model.enabledSingleBundleCatalogRound = true;                               // ラジオボタン単企画回への選定を活性 

      if (selectedMediumTypeList.BundleCatalogFlag === '0') {
        // 束ねフラグが'0'(束ね企画対象でない)の媒体の場合
        this.kymw1300Model.kymw1300Component.txt_OrderCode.required = true;                      // 受注コードの背景を黄色
        this.kymw1300Model.enabledBundleCatalogGuideStandardName = false;                        // 束ね企画名非活性
        this.cmb_SellArea.setMediumType(mediumType, '20', null);                                 // 売り場の初期値は20：中面
        this.cmb_SellArea.disabled = false;                                                      // 売り場を活性
      } else if (selectedMediumTypeList.BundleCatalogFlag === '1') {
        // 束ねフラグが'1'(束ね企画対象)の媒体の場合
        this.kymw1300Model.kymw1300Component.txt_OrderCode.required = false;                     // 受注コードの背景を白色
        this.cmb_SellArea.setMediumType(mediumType, '20', null);                                 // 売り場を20：中面に固定
        this.kymw1300Model.enabledBundleCatalogGuideStandardName = true;                         // 束ね企画名活性
        this.cmb_SellArea.disabled = true;                                                       // 売り場を非活性
        // 束ね企画回情報一覧取得API用VO
        const vo = {
          mediumType: this.kymw1300Model.mediumType
        }
        this.getBundleCatalogRoundInfoListService.execute(vo, (data: any) => this.getBundleCatalogRoundInfoListServiceSuccessFunc(data));  // 22. 束ね企画回情報一覧取得API呼び出し
      }
    }

    this.kymw1300Model.bundleCatalogGuideStandardName = '';                                  // 束ね企画名クリア
    this.kymw1300Model.startOrderCode = '';                                                  // 開始受注コードクリア
    this.kymw1300Model.endOrderCode = '';                                                    // 終了受注コードクリア
    this.kymw1300Model.featureCodeList = [];                                                 // 特集コードクリア

    // バンドルミックスマッチボタン活性制御
    this.changeEnableBundleMixMatch();

    // 「Ｗ掲載設定画面」の表示制御をする。
    if (!this.kymw1300Model.isDutiesFormWeekly()) {           // 「ウィークリーでない」の場合
      // Ｗ掲載設定画面が表示されていたら画面を閉じる
      if (this.isOpened('KYMW1310')){
        this.kymw1310cmp.onClickWindowClose();
        this.kymw1310cmp = null;
      }                      
    }

    // 「セット企画設定」の表示制御をする。
    if (this.isOpened('KYMW1312')){
      this.kymw1312cmp.setIsGroupNormal(this.kymw1300Model.isGroupNormal());
    }
  }

  /**
   * 束ね企画情報一覧を取得API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public getBundleCatalogRoundInfoListServiceSuccessFunc(data): void {
    this.kymw1300Model.bundleCatalogRoundInfoList = data.BundleCatalogRoundList;
  }

  /**
   * 特集コード一覧取得API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public getFeatureCodeListServiceSuccessFunc(data): void {
    if (data.FeatureCodeList.length !== 0) {
      this.kymw1300Model.featureCodeList = data.FeatureCodeList;
    }
  }

  /**
   * 束ね企画名変更時に呼び出される
   *
   * @memberof KYMW1300Component
   */
  public eventBundleCatalogGuideStandardName_CHANGEHandler(event: Event): void {
    this.kymw1300_02.targetSetModel.clearList();
    this.kymw1300_03.selectedModel.clearList();

    //開始受注コード・終了受注コードをセットする
    this.selectElement = event.target as HTMLSelectElement;
    this.kymw1300Model.BundleCatalogRoundId = this.selectElement.value;
    this.kymw1300Model.selectedBundleCatalogRoundInfoList = this.kymw1300Model.bundleCatalogRoundInfoList.filter(item => item.BundleCatalogRoundId === this.selectElement.value);
    this.kymw1300Model.startOrderCode = this.kymw1300Model.selectedBundleCatalogRoundInfoList[0].StartOrderCode;
    this.kymw1300Model.endOrderCode = this.kymw1300Model.selectedBundleCatalogRoundInfoList[0].EndOrderCode;
    this.kymw1300Model.delivCatalogIdOfStartOrderCode = this.kymw1300Model.selectedBundleCatalogRoundInfoList[0].DelivCatalogId; //束ね企画開回始受注コードに紐づく配達企画回
    this.kymw1300Model.kymw1300Component.txt_OrderCode.required = false;                     // 受注コードの背景を白色
    // 「編集ロック」を"閲覧モード"にする。
    this.setEditLock(false);
    this.setLockButtonStyle(false);

    // 受注コードが束ね企画回の範囲内か判定
    this.eventOrederCode_FOCUSOUTHandler();

    // 束ね企画名の選択があるとき
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.bundleCatalogGuideStandardName)) {
      // 共通コンポーネントに渡す受注コードに束ね企画の開始受注コードを設定
      this.kymw1300Model.componentOrderCode = this.kymw1300Model.startOrderCode;
      this.kymw1300Model.radioGroup = '1'                                                      // ラジオボタン束ね企画回への選定にチェック
      this.kymw1300Model.enabledBundleCatalogRound = true;                                     // ラジオボタン束ね企画回への選定を活性

      const getFeatureCodeVO = {                                                               // 23. 特集コード一覧取得API呼び出し
        orderCode: this.kymw1300Model.componentOrderCode,
        mediumType: this.kymw1300Model.mediumType
      }
      this.getFeatureCodeListService.execute(getFeatureCodeVO, (data: any) => this.getFeatureCodeListServiceSuccessFunc(data));

      // 企画管理情報取得APIリクエストVO初期化処理
      const voCatalogInfo = {
        orderCode: this.kymw1300Model.componentOrderCode,
      };

      // 企画管理情報取得API呼び出し
      this.getCatalogInfoService.execute(this.kymw1300Model, voCatalogInfo,
        (data: any) => this.getCatalogInfoServiceSuccessFunc(data, true));
    } else {
      this.kymw1300Model.radioGroup = ''                                                       // ラジオボタンチェックを外す
      this.kymw1300Model.enabledBundleCatalogRound = false;                                    // ラジオボタン束ね企画回への選定を非活性
    }

    // 受注コードが有効
    if (this.txt_OrderCode.isValidOrderCode()) {
      // 共通コンポーネントに渡す受注コードに画面の受注コードを設定
      this.kymw1300Model.componentOrderCode = this.kymw1300Model.orderCode;
    } else {
      // 受注コードが無効
      // 共通コンポーネントに渡す受注コードに束ね企画の開始受注コードを設定
      this.kymw1300Model.componentOrderCode = this.kymw1300Model.startOrderCode;

      this.kymw1300_03.cmb_PageNo.orderCode = this.kymw1300Model.componentOrderCode;
      this.kymw1300_03.cmb_PageNo.mediumType = this.kymw1300Model.mediumType;
    }

    // バンドルミックスマッチボタン活性制御
    this.changeEnableBundleMixMatch();

    // 注文コード取得
    this.getOrderNumQuota();
  }

  /**
   * 注文コード取得
   * 
   */
  public getOrderNumQuota(): void {
    const orderNum = this.txt_OrderCode.isValidOrderCode();  // 受注コードが有効の場合 true
    const mediumType = !PlessViewUtilsSub.isEmpty(this.kymw1300Model.mediumType);                    // 媒体選択がある場合       true
    const bundle = !PlessViewUtilsSub.isEmpty(this.kymw1300Model.bundleCatalogGuideStandardName);    // 束ね企画名選択がある場合  true

    // 受注コードが入力済みの場合、受注コードに画面の受注コードを設定する。
    if (orderNum) {
      this.kymw1300_02.cmb_OrderNumQuota.orderCode = this.kymw1300Model.orderCode;
      this.kymw1300_03.cmb_OrderNumQuota_Selected.orderCode = this.kymw1300Model.orderCode;
    } else if (bundle) {
      // 受注コードが未入力の場合、受注コードに束ね企画の開始受注コードを設定する。
      this.kymw1300_02.cmb_OrderNumQuota.orderCode = this.kymw1300Model.startOrderCode;
      this.kymw1300_03.cmb_OrderNumQuota_Selected.orderCode = this.kymw1300Model.startOrderCode;
    }

    if ( (orderNum && mediumType) || 
         (bundle && mediumType && PlessViewUtilsSub.isEmpty(this.kymw1300Model.orderCode)) ) {  // 受注コード入力中ではないとき
      // 注文コード割当取得
      this.kymw1300_02.cmb_OrderNumQuota.mediumType = this.kymw1300Model.mediumType;
      this.kymw1300_02.cmb_OrderNumQuota.reload();
      this.kymw1300_03.cmb_OrderNumQuota_Selected.mediumType = this.kymw1300Model.mediumType;
      this.kymw1300_03.cmb_OrderNumQuota_Selected.reload();

    } else {
      // 注文コードを空にする
      this.kymw1300_02.cmb_OrderNumQuota.clear();
      this.kymw1300_03.cmb_OrderNumQuota_Selected.clear();
      this.kymw1300_02.cmb_OrderNumQuota.orderCode = <string>'';
      this.kymw1300_02.cmb_OrderNumQuota.mediumType = <string>'';
      this.kymw1300_03.cmb_OrderNumQuota_Selected.orderCode = <string>'';
      this.kymw1300_03.cmb_OrderNumQuota_Selected.mediumType = <string>'';
    }
  }

  /**
   * 売り場区分変更
   * 媒体区分コンボボックスの変更時に呼び出される処理
   *
   * @memberof KYMW1300Component
   */
  public sellArea_CHANGEDHandler(): void {
    // データグリッド行の選択解除
    this.kymw1300_03.dg_SelectedItemList.select(-1, -1);

    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.orderCode)) {
      // 選定済一覧・検索フラグのチェック
      if (!this.kymw1300_03.selectedModel.searchFlg) {                            // 「false：未検索」の場合
        // 06. 予算・計画数一覧取得APIリクエストVO初期化処理
        const getPlanNumListVO: KYMW1300GetPlanNumListModel = this.kymw1300Model.setGetPlanNumListVO();

        // 06. 予算・計画数一覧取得API呼び出し
        this.getPlanNumListService.execute(this.kymw1300Model, getPlanNumListVO,
          (data: any) => this.getPlanNumListServiceSuccessFunc(data, getPlanNumListVO));
      } else {                                                                    // 「true：検索済」の場合
        // 05. 選定済一覧取得APIリクエストVO初期化処理
        const getSearchSelectedListVO: KYMW1300GetSearchSelectedListModel = this.kymw1300Model.setGetSelectedListVO();

        // 検索条件を保持しておき次回検索がページングの場合に利用する
        this.kymw1300Model.lastTimeGetSelectedListVO = getSearchSelectedListVO;

        // 05. 選定済一覧取得API呼び出し
        this.getSelectedListService.execute(this.kymw1300Model, getSearchSelectedListVO,
          (data: any) => this.getSelectedListServiceSuccessFunc(data, getSearchSelectedListVO));
      }
      // 画面の受注コードを設定し特集コード一覧取得API呼び出し
      const getFeatureCodeVO = {
        orderCode: this.kymw1300Model.orderCode,
        mediumType: this.kymw1300Model.mediumType
      }
      this.getFeatureCodeListService.execute(getFeatureCodeVO, (data: any) => this.getFeatureCodeListServiceSuccessFunc(data));
    } else {
      // 画面のクリア処理を行う
      this.kymw1300Model.clearList();
      this.kymw1300_03.selectedModel.clearList();

      this.kymw1300_02.cmb_OrderNumQuota.orderCode = <string>'';
      this.kymw1300_02.cmb_OrderNumQuota.mediumType = <string>'';
      this.kymw1300_03.cmb_OrderNumQuota_Selected.orderCode = <string>'';
      this.kymw1300_03.cmb_OrderNumQuota_Selected.mediumType = <string>'';

      this.cmb_SellArea.clear();
      this.kymw1300_02.cmb_OrderNumQuota.clear();
      this.kymw1300_03.cmb_OrderNumQuota_Selected.clear();
      this.kymw1300_03.cmb_PageNo.clear();

      // バンドルミックスマッチ設定画面の再表示
      this.refleshTargetWindow('KYMW1308');

      // 子画面の再表示
      this.refleshTargetWindow();
    }
  }

  /**
   * 売り場(コンボボックス)_変更時に呼び出される
   *
   * @returns {void}
   * @memberof KYMW1300Component
   */
  public eventSellArea_CHANGEHandler(): void {
    //受注コードが入力済み
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.orderCode)) {
      // 05. 選定済一覧取得APIリクエストVO初期化処理
      const getSearchSelectedListVO: KYMW1300GetSearchSelectedListModel = this.kymw1300Model.setGetSelectedListVO();

      // 検索条件を保持しておき次回検索がページングの場合に利用する
      this.kymw1300Model.lastTimeGetSelectedListVO = getSearchSelectedListVO;

      // 05. 選定済一覧取得API呼び出し
      this.getSelectedListService.execute(this.kymw1300Model, getSearchSelectedListVO,
        (data: any) => this.getSelectedListServiceSuccessFunc(data, getSearchSelectedListVO));

      // 選定済一覧・検索フラグのチェック
      if (!this.kymw1300_03.selectedModel.searchFlg) {                            // 「false：未検索」の場合
        // Pコード一発選定(メインメニュー)の活性制御を行う
        this.setEnabledKYMW1304();

        // 処理復帰
        return;
      }
    } else {
      //受注コードが未入力
      // 画面のクリア処理を行う
      this.kymw1300Model.clearList();
      this.kymw1300_03.selectedModel.clearList();

      // バンドルミックスマッチ設定画面の再表示
      this.refleshTargetWindow('KYMW1308');

      // 子画面の再表示
      this.refleshTargetWindow();
    }
    // データグリッド行の選択解除
    this.kymw1300_03.dg_SelectedItemList.select(-1, -1);
  }

  /**
   * 表示切替(ボタン)_クリック時に呼び出される
   * 選定候補一覧、選定済一覧の表示・非表示を切り替える
   *
   * @memberof KYMW1300Component
   */
  public toggleSelectTargetListView(): void {
    // 表示切替カウンタを加算
    this.kymw1300Model.cntDispChange = this.kymw1300Model.cntDispChange % 3 + 1;
    // 選定候補一覧のグリッドサイズを変更する
    this.kymw1300_02.resizeFlexGrid();
    // 選定済一覧のグリッドサイズを変更する
    this.kymw1300_03.resizeFlexGrid();
  }

  /**
   * 編集ロック(ボタン)_クリック時に呼び出される
   *
   * @returns {void}
   * @memberof KYMW1300Component
   */
  public eventEditLock_CLICKHandler(): void {
    // ロック状態のチェック
    if (this.getIcnEditLock()) {                                                // 「true：編集」の場合
      // 「編集モードから閲覧モードに切り替えようとした場合

      this.setLockButtonStyle(false);

      // 「セット企画設定画面」が閉じている時
      if (!this.isOpened('KYMW1312')) {
        // 「編集ロック」の閲覧/編集モードを切り替える
        this.switchEditLock(PlessAlert.Yes);
        return;
      }

      if (this.kymw1312cmp.getEditCount() > 0) {
        // 確認メッセージ表示(変更内容を破棄)
        this.dialogService.openAlertGetMessage('Q0107', ['セット企画プロモーション情報'],
          (detail: number) => this.switchEditLock(detail));
      } else {
        // 「編集ロック」の閲覧/編集モードを切り替える
        this.switchEditLock(PlessAlert.Yes);
      }
    } else {                                                                    // 「false：閲覧」の場合
      // 「閲覧モードから編集モードに切り替えようとした場合

      this.setLockButtonStyle(true);

      // 「編集ロック」の閲覧/編集モードを切り替える
      this.switchEditLock(PlessAlert.Yes);
    }
  }

  /**
   * 編集ロック切替
   *
   * @private
   * @param {number} detail ダイアログ押下ボタン
   * @memberof KYMW1300Component
   */
  private switchEditLock(detail: number): void {
    // ダイアログ押下ボタンのチェック
    if (detail === PlessAlert.Yes) {                                             // 「4：Ok」の場合
      // 編集モードの切り替え処理結果のチェック
      if (!this.setEditLock(this.clsLock === this.BUTTON_STYLE_SELECTED)) {     // 「false：切替失敗」の場合
        this.clsLock = this.BUTTON_STYLE_DEFAULT;
        this.setLockButtonStyle(false);
      }
    } else {                                                                    // 上記以外の場合
      this.setLockButtonStyle(true);
    }
  }

  /**
   * ロックボタンスタイル制御
   *
   * @param {boolean} selected ロック状態(true：編集、false：閲覧)
   * @memberof KYMW1400KomaPageComponent
   */
  public setLockButtonStyle(selected: boolean) {
    // ロック状態のチェック
    if (selected) {                                                             // 「true：編集」の場合
      this.clsLock = this.BUTTON_STYLE_SELECTED;
      this.kymw1300Model.srcLock = './assets/icons/KYMW14/unlock.png';
    } else {                                                                    // 上記以外の場合
      this.clsLock = this.BUTTON_STYLE_DEFAULT;

      // 権限のチェック
      if (this.getFuncPermission() !== this.kymw00Model.FUNC_PERMISSION_FULLCONTROL) {  // 「2：フルコントロール可能」以外の場合
        this.kymw1300Model.srcLock = './assets/icons/KYMW14/disabledlock.png';
      } else {                                                                  // 上記以外の場合
        this.kymw1300Model.srcLock = './assets/icons/KYMW14/lock.png';
      }
    }
  }

  /**
   * ヘッダー情報入力チェック
   *
   * @param blnMedium 媒体区分チェック要否
   * @param blnSell 売り場区分チェック要否
   * @return チェック結果
   */
  public checkInputHeader(blnMedium = false, blnSell = false): boolean {
    // 必須チェック：受注コードまたは束ね企画名
    if ((PlessViewUtilsSub.isEmpty(this.kymw1300Model.orderCode)) && (PlessViewUtilsSub.isEmpty(this.kymw1300Model.bundleCatalogGuideStandardName))) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード、束ね企画名どちらか'], () => { });
      return false;
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.orderCode)) {
      // 妥当性チェック：受注コード
      if (!this.txt_OrderCode.isValidOrderCode()) {
        this.dialogService.openAlertGetMessage('W0024', ['受注コード'], () => { });
        return false;
      }
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.startOrderCode)) {
      // 妥当性チェック：束ね企画回開始受注コード
      if (!this.isValidStartOrderCode()) {
        this.dialogService.openAlertGetMessage('W0024', ['束ね企画回開始受注コード'], () => { });
        return false;
      }
    }

    // 必須チェック：媒体区分
    if (blnMedium
      && PlessViewUtilsSub.isEmpty(this.kymw1300Model.mediumType)) {
      this.dialogService.openAlertGetMessage('W0001', ['媒体'], () => { });
      return false;
    }

    // 必須チェック：売り場区分
    if (blnSell
      && PlessViewUtilsSub.isEmpty(this.cmb_SellArea.selectedSellAreaCode)) {
      this.dialogService.openAlertGetMessage('W0001', ['売場'], () => { });
      return false;
    }

    return true;
  }

  /**
   * 編集モードの切り替えを行う
   *
   * @param editLock 編集モード(true：ロック取得、false：ロック解除)
   * @return 切替結果(true：切替成功、false：切替失敗)
   */
  public setEditLock(editLock: boolean): boolean {

    const mediumType: string = this.kymw1300Model.mediumType;

    // 入力パラメータの編集モードのチェック
    if (editLock) {                                                             // 「true：ロック取得」の場合
      // 編集モードを"編集"に切り替える

      // 必須チェックと妥当性チェック：受注コードまたは束ね企画名
      if (!this.checkInputHeader()) {
        return false;
      }

      // 工程管理NOのチェックを行う
      for (const item of this.kymw1300Model.catalogProgress) {
        // 工程管理NOのチェックを行う
        if (Number(item.ProgressWorkNum) >= 7) {                                // 「07：企画確定」以降の場合
          // 媒体区分の選択有無チェック
          if (!PlessViewUtilsSub.isEmpty(mediumType)) {                         // 選択ありの場合
            // 媒体区分の比較
            if (mediumType === item.MediumType) {                               // 同一媒体区分の場合
              this.dialogService.openAlertGetMessage('E0149', null, () => { });
              return false;
            }
          } else {                                                              // 選択なしの場合
            this.dialogService.openAlertGetMessage('E0238', null, () => { });
            return false;
          }
        }
      }

      // 『バンドルミックスマッチ設定』画面の再表示を行う
      this.refleshTargetWindow('KYMW1308');

      if (this.isOpened('KYMW1312')) {
        // 『セット企画設定』画面の再表示(再度開く)を行う
        const kymw1312vo: KYMW1312InputModel = this.kymw1300Model.setKYMW1312InputVO();
        kymw1312vo.accessDiv = '1';

        // 選択行の内容で再表示
        this.kymw1312cmp.setInputVO(kymw1312vo);
      }
    } else {                                                                    // 上記以外の場合

      // 『バンドルミックスマッチ設定』画面の再表示を行う
      this.refleshTargetWindow('KYMW1308');

      if (this.isOpened('KYMW1312')) {
        // セット企画設定画面を閉じる
        this.kymw1312cmp.eventClose_CLICKHandler(null);
      }
    }

    this.kymw1300Model.editLock = editLock;

    // 子画面の再表示を行う
    this.refleshTargetWindow();

    // ボタンの活性制御を行う
    this.plessEnabled(this.kymw1300_03.btn_nextGuideBatchSet, editLock);
    this.plessEnabled(this.kymw1300_03.btn_nextGuideCheck, editLock);

    // デイリー媒体、スポット媒体時は非活性にする
    if (!this.kymw1300Model.isDutiesFormWeeklyOrDivPeriod()) {                             // [false：ウィークリーでない」の場合
      this.plessEnabled(this.kymw1300_03.btn_nextGuideBatchSet, false);
      this.plessEnabled(this.kymw1300_03.btn_nextGuideCheck, false);
    }

    // 切替結果(true：切替成功)を返却
    return true;
  }

  /**
   * 子画面の再表示を行う
   *
   * @param {string} [target=<string>''] 画面ID
   * @param onComplete 後続処理
   * @memberof KYMW1300Component
   */
  public refleshTargetWindow(target: string = <string>'', onComplete?: () => void): void {

    // 選定済一覧の選択行番号
    const index: number = this.kymw1300_03.dg_SelectedItemList.selection.row;
    let pCode: string = <string>'';

    // 排他情報・Ｐコードのチェック
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.lockPCode)) {             // 指定ありの場合
      // 選択行番号のチェック
      if (index > -1) {                                                         // 行選択ありの場合

        // 選択Ｐコード取得
        pCode = this.kymw1300Model.getSelectedPCode();

        // 編集ロックが「編集モード」の場合かつ、ロックしているPコードと選定済み一覧で選択しているPコードが違う場合
        // または、編集ロックが「閲覧モード」の場合かつ、ロックしているPコードと選定済み一覧で選択しているPコードが同じ場合
        if ((this.kymw1300Model.lockPCode !== pCode && this.kymw1300Model.editLock)
          || (this.kymw1300Model.lockPCode === pCode && !this.kymw1300Model.editLock)) {
          // ロック情報のリリースを行う
          this.LockUtilForPlanGoods('RELEASE',
            this.kymw1300Model.lockOrderCode, this.kymw1300Model.lockMediumType, this.kymw1300Model.lockPCode,
            () => this.refleshTargetWindowAfterPCodeLock(pCode, index, target, onComplete), null,
            () => this.refleshTargetWindowAfterPCodeLock(pCode, index, target, onComplete), null,
            false);

          // ロック解除処理
          this.deleteLockInfo();
        } else {
          this.refleshTargetWindowAfterPCodeLock(pCode, index, target, onComplete);
        }
      } else {                                                                  // 行選択なしの場合
        // ロック情報のリリースを行う
        this.LockUtilForPlanGoods('RELEASE',
          this.kymw1300Model.lockOrderCode, this.kymw1300Model.lockMediumType, this.kymw1300Model.lockPCode,
          () => this.refleshTargetWindowAfterPCodeLock(pCode, index, target, onComplete), null,
          () => this.refleshTargetWindowAfterPCodeLock(pCode, index, target, onComplete), null,
          false);

        // ロック解除処理
        this.deleteLockInfo();
      }
    } else {
      this.refleshTargetWindowAfterPCodeLock(pCode, index, target, onComplete);
    }
  }

  /**
   * 子画面の再表示時のPコードロック後の処理
   *
   * @param pCode Pコード
   * @param index 選定済一覧の選択行番号
   * @param target 対象の子画面ID
   * @param onComplete 後続処理
   */
  private refleshTargetWindowAfterPCodeLock(pCode: string, index: number, target: string, onComplete?: () => void) {
    // 排他情報・Ｐコード・KYMW0800画面のチェック
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.lockPCode_KYMW0800)) {    // 指定ありの場合
      // 選択行番号のチェック
      if (index > -1) {                                                         // 行選択ありの場合

        // 選択Ｐコード取得
        pCode = this.kymw1300Model.getSelectedPCode();

        // 編集ロックが「編集モード」の場合かつ、ロックしているPコードと選定済み一覧で選択しているPコードが違う場合
        // または、編集ロックが「閲覧モード」の場合かつ、ロックしているPコードと選定済み一覧で選択しているPコードが同じ場合
        if ((this.kymw1300Model.lockPCode_KYMW0800 !== pCode && this.kymw1300Model.editLock)
          || (this.kymw1300Model.lockPCode_KYMW0800 === pCode && !this.kymw1300Model.editLock)) {
          // ロック情報のリリースを行う
          this.LockUtilForPlanGoods('RELEASE',
            this.kymw1300Model.lockOrderCode, this.kymw1300Model.lockMediumType, this.kymw1300Model.lockPCode_KYMW0800,
            () => {
              this.refleshTargetWindowAfterPCode_KYMW0800Lock(pCode, index, target);
              if(onComplete) onComplete();
            }, null,
            () => {
              this.refleshTargetWindowAfterPCode_KYMW0800Lock(pCode, index, target);
              if(onComplete) onComplete();
            }, null,
            false);

          // ロック解除処理
          this.deleteLockInfo();
        } else {
          this.refleshTargetWindowAfterPCode_KYMW0800Lock(pCode, index, target);
          if(onComplete) onComplete();
        }
      } else {                                                                  // 行選択なしの場合
        // ロック情報のリリースを行う
        this.LockUtilForPlanGoods('RELEASE',
          this.kymw1300Model.lockOrderCode, this.kymw1300Model.lockMediumType, this.kymw1300Model.lockPCode_KYMW0800,
          () => {
            this.refleshTargetWindowAfterPCode_KYMW0800Lock(pCode, index, target);
            if(onComplete) onComplete();
          }, null,
          () => {
            this.refleshTargetWindowAfterPCode_KYMW0800Lock(pCode, index, target);
            if(onComplete) onComplete();
          }, null,
          false);

        // ロック解除処理
        this.deleteLockInfo();
      }
    } else {
      this.refleshTargetWindowAfterPCode_KYMW0800Lock(pCode, index, target);
      if(onComplete) onComplete();
    }
  }

  /**
   * 子画面の再表示時のKYMW0800_Pコードロック後の処理
   *
   * @param pCode Pコード
   * @param index 選定済一覧の選択行番号
   * @param target 対象の子画面ID
   */
  private refleshTargetWindowAfterPCode_KYMW0800Lock(pCode: string, index: number, target: string) {
    // 画面IDのチェック
    if (target === 'KYMW1308') {                                                // 「KYMW1308：バンドルミックスマッチ設定画面」の場合
      // バンドルミックスマッチ設定の起動状況のチェック
      if (this.isOpened('KYMW1308')) {                                          // 起動済みの場合
        const kymw1308vo: KYMW1308InputModel = this.kymw1300Model.setKYMW1308InputVO();
        this.kymw1308cmp.setInputVO(kymw1308vo);
      }
    }

    // 画面IDのチェック
    if (target === 'KYMW1312') {                                                // 「KYMW1312：セット企画設定画面」の場合
      // セット企画画面の起動状況のチェック
      if (this.isOpened('KYMW1312')) {                                          // 起動済みの場合
        const kymw1312vo: KYMW1312InputModel = this.kymw1300Model.setKYMW1312InputVO();
        this.kymw1312cmp.setInputVO(kymw1312vo);
      }
    }

    // 画面IDのチェック
    if (PlessViewUtilsSub.isEmpty(target) || target === 'KYMW1307') {           // 指定なし、「KYMW1307：予算・計画・実績表画面」の場合
      // 予算計画実績表画面の起動状況のチェック
      if (this.isOpened('KYMW1307')) {                                          // 起動済みの場合
        const kymw1307vo: KYMW1307InputModel = this.kymw1300Model.setKYMW1307InputVO();

        // 選択行の内容で再表示
        this.kymw1307cmp.setInterfaceParam(kymw1307vo);
      }
    }

    // 排他制御
    // 画面の起動状況のチェック
    if (this.isOpened('KYMW0800')                                              // 実績履歴画面が起動済み、
      || this.isOpened('KYMW1310')) {                                            // Ｗ掲載設定画面が起動済みの場合

      // 編集ロック、行選択有無のチェック
      if (this.kymw1300Model.editLock && index > -1) {                          // ロック取得、行選択ありの場合

        // 選択Ｐコード、媒体区分を取得
        pCode = this.kymw1300Model.getSelectedPCode();
        const mediumType = this.kymw1300_03.dg_SelectedItemList.selectedItems[0].MediumType;

        // 選択Ｐコードのチェック
        if (!PlessViewUtilsSub.isEmpty(pCode)) {                                // 指定ありの場合
          // 排他ロックを行う
          if (target !== 'KYMW1307') {
            this.LockUtilForPlanGoods('REGIST',
              this.kymw1300Model.orderCode, mediumType, pCode,
              (successParam: any) => {
                this.lockOKFunc_Reflesh(successParam);
              }, target,
              (faultParam: any) => {
                this.lockErrFunc_Reflesh(faultParam);
              }, target,
              false);
          }
        } else {                                                                // 指定なしの場合
          // 子画面再表示処理
          this.refleshChildWindow(target, false);
        }
      } else {                                                                  // 上記以外の場合
        // 子画面再表示処理
        this.refleshChildWindow(target, false);
      }
    }
  }


  // サブ画面からのOutput処理 START

  /**
   * 商品検索画面 Output時
   *
   * @param {KYMW0300OutputModel} outputVO
   * @memberof KYMW1300TargetListComponent
   */
  public setKYMW0300Parameter(outputVO: KYMW0300OutputModel): void {
    let getPlanTargetListVO: KYMW1300GetPlanTargetListModel = null;
    const planTargetList: PlanTargetList = [
      {
        guideGoodsName: outputVO.guideGoodsNameList as Array<string>,
        guideStandardName: outputVO.guideStandardNameList as Array<string>,
        tagId: outputVO.tagId as Array<string>,
        goodsMark: outputVO.goodsMark as Array<string>,
        coopCode: outputVO.coopCodeList as Array<string>,
        catalogCode: outputVO.catalogCode as Array<string>,
        pageNo: outputVO.pageNo as Array<string>,
        duties: outputVO.duties as Array<string>,
        pcodeList: outputVO.pcodeList as Array<string>,
        itemCodeList: outputVO.itemcodeList as Array<string>,
      }
    ];

    // 04. 選定候補一覧(候補セット)取得APIリクエストVO初期化処理
    getPlanTargetListVO = this.kymw1300Model.setGetPlanTargetListVO(this.kymw1300_02.targetSetModel, outputVO, Boolean(false));
    getPlanTargetListVO.focusFlg = '01';

    if (PlessViewUtilsSub.isEmpty(getPlanTargetListVO.orderCode)) {
      this.dialogService.openAlertGetMessage('W0001', ['受注コード'], () => { });
      return
    }
    if (PlessViewUtilsSub.isEmpty(getPlanTargetListVO.page)) {
      this.dialogService.openAlertGetMessage('W0001', ['表示ページ'], () => { });
      return
    }

    // 04. 選定候補一覧(候補セット)取得API呼び出し
    this.getPlanTargetListService.execute(this.kymw1300Model, getPlanTargetListVO, planTargetList,
      (data: any) => this.getPlanTargetListServiceSuccessFunc(data, getPlanTargetListVO));
  }

  /**
   * 取引先一覧画面 Output時
   *
   * @param {KYMW0400OutputModel} outputVO
   * @memberof KYMW1300Component
   */
  public setKYMW0400Parameter(outputVO: KYMW0400OutputModel): void {
    // 呼出元区分のチェック
    if (outputVO.supplierFlg === '0') {                                         // 「0：発注先」の場合
      this.kymw1300_03.selectedModel.orderClientCode = outputVO.supplierCode;
      this.kymw1300_03.selectedModel.orderClientKanji = outputVO.supplierNameKanji;
    } else if (outputVO.supplierFlg === '1') {                                  // 「1：支払先」の場合
      this.kymw1300_03.selectedModel.payeeClientCode = outputVO.supplierCode;
      this.kymw1300_03.selectedModel.payeeClientKanji = outputVO.supplierNameKanji;
    }
  }

  /**
   * 紐付設定画面 Output時
   *
   * @param {KYMW0500OutputModel} outputVO
   * @memberof KYMW1300Component
   */
  public setKYMW0500Parameter(outputVO: KYMW0500OutputModel): void {
    // 05. 選定済一覧取得APIリクエストVO初期化処理
    const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.kymw1300Model.setGetSelectedListVO(true);
    getSelectedListVO.searchPCode = this.kymw1300Model.getSelectedPCode();

    // 検索条件を保持しておき次回検索がページングの場合に利用する
    this.kymw1300Model.lastTimeGetSelectedListVO = getSelectedListVO;

    // 05. 選定済一覧取得API呼び出し
    this.getSelectedListService.execute(this.kymw1300Model, getSelectedListVO,
      (data: any) => this.getSelectedListServiceSuccessFunc(data, getSelectedListVO));
  }

  /**
   * 実績履歴画面 Output時
   *
   * @param {KYMW0800OutputModel} outputVO
   * @memberof KYMW1300Component
   */
  public setKYMW0800Parameter(outputVO: KYMW0800OutputModel): void {
    // 05. 選定済一覧取得APIリクエストVO初期化処理
    const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.kymw1300Model.setGetSelectedListVO(true);
    getSelectedListVO.searchPCode = this.kymw1300Model.getSelectedPCode();

    // 検索条件を保持しておき次回検索がページングの場合に利用する
    this.kymw1300Model.lastTimeGetSelectedListVO = getSelectedListVO;

    // 05. 選定済一覧取得API
    this.getSelectedListService.execute(this.kymw1300Model, getSelectedListVO,
      (data: any) => this.getSelectedListServiceSuccessFunc(data, getSelectedListVO));
  }

  /**
   * 商品企画メンテナンス画面 Output時
   *
   * @param {KYMW0900OutputModel} outputVO
   * @memberof KYMW1300Component
   */
  public setKYMW0900Parameter(outputVO: KYMW0900OutputModel): void {

    // 表示中データの再表示を行う
    // 選定候補一覧

    // 選定候補一覧の選定候補リストのサイズチェック
    if (this.kymw1300_02.targetSetModel.selectTargetList.length > 0) {              // 該当データあり(検索済み)の場合
      // 02. 選定候補一覧(定番)取得APIリクエストVO初期化処理
      let getPlanTargetListVO: KYMW1300GetPlanTargetListModel = null;
      getPlanTargetListVO = this.kymw1300Model.setGetPlanTargetListVO(this.kymw1300_02.targetSetModel, null, Boolean(true));
      const planTargetList: PlanTargetList = [
        {
          guideGoodsName: getPlanTargetListVO.guideGoodsName as Array<string>,
          guideStandardName: getPlanTargetListVO.guideStandardName as Array<string>,
          tagId: getPlanTargetListVO.tagId as Array<string>,
          goodsMark: getPlanTargetListVO.goodsMark as Array<string>,
          coopCode: getPlanTargetListVO.coopCode as Array<string>,
          catalogCode: getPlanTargetListVO.catalogCode as Array<string>,
          pageNo: getPlanTargetListVO.pageNo as Array<string>,
          duties: getPlanTargetListVO.duties as Array<string>,
          pcodeList: getPlanTargetListVO.pcodeList as Array<string>,
          itemCodeList: getPlanTargetListVO.itemCodeList as Array<string>,
        }
      ];

      if (PlessViewUtilsSub.isEmpty(getPlanTargetListVO.orderCode)) {
        this.dialogService.openAlertGetMessage('W0001', ['受注コード'], () => { });
        return
      }
      if (PlessViewUtilsSub.isEmpty(getPlanTargetListVO.page)) {
        this.dialogService.openAlertGetMessage('W0001', ['表示ページ'], () => { });
        return
      }
      // 02. 選定候補一覧(定番)取得API呼び出し
      this.getPlanTargetListService.execute(this.kymw1300Model, getPlanTargetListVO, planTargetList,
        (data: any) => {
          this.getPlanTargetListServiceSuccessFunc(data, getPlanTargetListVO);
        });
    }

    // 05. 選定済一覧取得APIリクエストVO初期化処理
    const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.kymw1300Model.setGetSelectedListVO(true);
    getSelectedListVO.searchPCode = this.kymw1300Model.getSelectedPCode();

    // 検索条件を保持しておき次回検索がページングの場合に利用する
    this.kymw1300Model.lastTimeGetSelectedListVO = getSelectedListVO;

    // 05. 選定済一覧取得API呼び出し
    this.getSelectedListService.execute(this.kymw1300Model, getSelectedListVO,
      (data: any) => this.getSelectedListServiceSuccessFunc(data, getSelectedListVO));
  }

  /**
   * Ｐコード一発選定画面 Output時
   *
   * @param {KYMW1304OutputModel} outputVO
   * @memberof KYMW1300Component
   */
  public async setKYMW1304Parameter(outputVO: KYMW1304OutputModel): Promise<boolean> {
    // 07. 商品選定確認APIリクエストVO初期化処理
    const registPlanVO: KYMW1300RegistPlanModel = new KYMW1300RegistPlanModel();
    const checkregistPlanVO: KYMW1300CheckRegistPlanModel = new KYMW1300CheckRegistPlanModel();
    let filteredOrderCodeList: Array<any> = new Array<any>();
    const selectedMediumTypeList = this.kymw1300Model.mediumTypeList.find(item => item.MediumType === this.kymw1300Model.mediumType);

    // 単企画回への選定にチェックが入っている
    if (this.kymw1300Model.radioGroup === '2') {
      if (PlessViewUtilsSub.isEmpty(this.kymw1300Model.orderCode)) {
        this.dialogService.openAlertGetMessage('W0001', ['受注コード'], () => { });
        return false;
      }
    }

    // 束ねフラグが'0'(束ね企画対象外)の媒体が選択されているかつ、単企画回への選定にチェックが入っている
    if (selectedMediumTypeList.BundleCatalogFlag === '0' && this.kymw1300Model.radioGroup === '2') {
      checkregistPlanVO.orderCodeList.push(this.kymw1300Model.orderCode);
      registPlanVO.orderCodeList.push(this.kymw1300Model.orderCode);
    }

    //  束ねフラグが'1'(束ね企画対象)の媒体が選択されているかつ、束ね企画回への選定にチェックが入っているかつ、受注コードが入力されていない場合
    if (selectedMediumTypeList.BundleCatalogFlag === '1' && this.kymw1300Model.radioGroup === '1' && PlessViewUtilsSub.isEmpty(this.kymw1300Model.orderCode)) {
      const selectedOrderCodeList = this.kymw1300Model.selectedBundleCatalogRoundInfoList[0].BundleCatalogOrderCodeList;
      checkregistPlanVO.orderCodeList = selectedOrderCodeList;
      registPlanVO.orderCodeList = selectedOrderCodeList;
    }

    // 束ね企画媒体が選択されているかつ、束ね企画回への選定にチェックが入っているかつ、受注コードが入力されている場合
    if (selectedMediumTypeList.BundleCatalogFlag === '1' && this.kymw1300Model.radioGroup === '1' && (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.orderCode))) {

      //入力された受注コード
      if (PlessViewUtilsSub.isEmpty(this.kymw1300Model.bundleCatalogGuideStandardName)) {
        this.dialogService.openAlertGetMessage('E0110', ['束ね企画名']);
        return false;
      } else {
        this.kymw1300Model.selectedBundleCatalogRoundInfoList = this.kymw1300Model.bundleCatalogRoundInfoList.filter(item => item.BundleCatalogRoundId === this.selectElement.value);
        // フィルターをかけて入力されている受注コードから束ね企画回の終了受注コードまでの間の受注コードをセットする
        filteredOrderCodeList = this.kymw1300Model.selectedBundleCatalogRoundInfoList[0].BundleCatalogOrderCodeList.filter(itemList =>
          parseInt(itemList) >= parseInt(this.kymw1300Model.orderCode));

        //入力されている受注コードから束ね企画回の終了受注コードまでの間の受注コード
        checkregistPlanVO.orderCodeList = filteredOrderCodeList;
        registPlanVO.orderCodeList = filteredOrderCodeList;
      }
    }

    // 束ねフラグが'1'(束ね企画対象)の媒体が選択されているかつ、単企画回への選定にチェックが入っている場合
    if (selectedMediumTypeList.BundleCatalogFlag === '1' && this.kymw1300Model.radioGroup === '2') {
      checkregistPlanVO.orderCodeList.push(this.kymw1300Model.orderCode);
      registPlanVO.orderCodeList.push(this.kymw1300Model.orderCode);
    }

    // 選定確認処理リクエスト用VO,選定処理リクエスト用VOにセット
    // 媒体区分
    if (PlessViewUtilsSub.isEmpty(this.kymw1300Model.mediumType)) {
      this.dialogService.openAlertGetMessage('E0110', ['媒体区分']);
      return false;
    } else {
      checkregistPlanVO.mediumType = this.kymw1300Model.mediumType;
      registPlanVO.mediumType = this.kymw1300Model.mediumType;
    }
    // 売り場コード
    if (PlessViewUtilsSub.isEmpty(this.cmb_SellArea.selectedSellAreaCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['売り場']);
      return false;
    } else {
      checkregistPlanVO.sellAreaCode = this.cmb_SellArea.selectedSellAreaCode;
      registPlanVO.sellAreaCode = this.cmb_SellArea.selectedSellAreaCode;
    }
    //　注文コード割当コード
    if (PlessViewUtilsSub.isEmpty(this.kymw1300_02.cmb_OrderNumQuota.selectedOrderNumQuotaCode)) {
      this.dialogService.openAlertGetMessage('E0110', ['注文コード割当']);
      return false;
    } else {
      checkregistPlanVO.orderNumQuotaCode = this.kymw1300_02.cmb_OrderNumQuota.selectedOrderNumQuotaCode;
      registPlanVO.orderNumQuotaCode = this.kymw1300_02.cmb_OrderNumQuota.selectedOrderNumQuotaCode;
    }
    //　特集コード
    checkregistPlanVO.featureCode = this.kymw1300Model.featureCode;
    registPlanVO.featureCode = this.kymw1300Model.featureCode;
    // Ｐコード
    if (PlessViewUtilsSub.isEmpty(outputVO.pcode)) {
      this.dialogService.openAlertGetMessage('E0110', ['Ｐコード']);
      return false;
    } else {
      checkregistPlanVO.RegistPlanPCodeList.push(outputVO.pcode);
      registPlanVO.pCodeList.push(outputVO.pcode);
    }

    // 選択している媒体が「03: クーポン媒体」もしくは「04: ポイント交換媒体」の場合、選定チェックを行う
    if (selectedMediumTypeList.MediumGroupDiv === '03' || selectedMediumTypeList.MediumGroupDiv === '04') {
      // 選定候補一覧を取得する
      let targetList = []; 
      const planTargetList: PlanTargetList = [
        {
          guideGoodsName: [] as Array<string>,
          guideStandardName: [] as Array<string>,
          tagId: [] as Array<string>,
          goodsMark: [] as Array<string>,
          coopCode: [] as Array<string>,
          catalogCode: [] as Array<string>,
          pageNo: [] as Array<string>,
          duties: [] as Array<string>,
          pcodeList: [outputVO.pcode] as Array<string>,
          itemCodeList: [] as Array<string>,
        }
      ];

      // 選定候補一覧(候補セット)取得APIリクエストVO初期化処理
      const getPlanTargetListVO: KYMW1300GetPlanTargetListModel = {
        orderCode: this.kymw1300Model.orderCode,
        mediumType: selectedMediumTypeList.MediumType,
        pcode: outputVO.pcode,
        itemCode: null,
        janCode: null,
        makerName: null,
        guideGoodsName: [],
        guideStandardName: [],
        tagSearchType: null,
        goodsMarkSearchType: null,
        dataKbnFlg: false,
        goodsDiv: null,
        buyerCode: null,
        admitStatus: null,
        registDateFrom: null,
        registDateTo: null,
        updateDateFrom: null,
        updateDateTo: null,
        classCode: null,
        middleClassCode: null,
        smallClassCode: null,
        ordrClientCode: null,
        ordrClientKanji: null,
        payeeClientCode: null,
        payeeClientKanji: null,
        duties: [],
        searchMediumType: null,
        searchOrderCode: null,
        specialFeature: null,
        catalogCode: [],
        catalogCodeSearchType: null,
        pageNo: [],
        page: '1',
        sortItem: null,
        sortOrder: null,
        tagId: [],
        goodsMark: [],
        coopCode: [],
        pcodeList: [outputVO.pcode],
        itemCodeList: [],
        bundleCatalogOrderCode: [],
        tagOutput: null,
        goodsMarkOutput: null,
        catalogId: null,
        catalogMarkOutput: null,
        pageInput: null,
        searchKbn: null,
        focusFlg: '01',
        refleshFlg: '1'
      }
       // 選定候補一覧(候補セット)取得API呼び出し
      // this.getPlanTargetListService.execute(this.kymw1300Model, getPlanTargetListVO, planTargetList,
      //   (data: any) => {
      //     for (let i = Number(0); i < data.SelectTargetList.length; i++) {
      //       targetList.push(data.SelectTargetList[i]);
      //     }
      //   }
      // );
      const targetResult = await this.execGetPlanTargetListAsync(this.kymw1300Model, getPlanTargetListVO, planTargetList);
      for (let i = Number(0); i < targetResult.SelectTargetList.length; i++) {
        targetList.push(targetResult.SelectTargetList[i]);
      }
      
      const errPCodes: string[] = [];
      for (const item of targetList) {
        // 選定されていない場合
        if (item.Status === '' || item.Status === '0' || item.Status === '1') {
          errPCodes.push(item.PCode);
          continue;
        }

        const vo = new GetDeletePlanGoodsInfoModel();
        vo.orderCode = this.kymw1300Model.orderCode;
        vo.pCode = item.PCode;
        vo.mediumType = selectedMediumTypeList.MediumType;

        try {
          const data = await this.execGetDeletePlanGoodsInfoAsync(vo);

          const mediumTypeList = data.DeletePlanGoodsTargetList.map((e) =>
            this.kymw1300Model.mediumTypeList.find(m => m.MediumType === e.MediumType)
          );

          let result = [];
          if (selectedMediumTypeList.MediumGroupDiv === '03'){
            result = mediumTypeList
              .filter(m => m?.MediumGroupDiv === '01' || m?.MediumGroupDiv === '02' || m?.MediumGroupDiv === '05');
          } else {
            result = mediumTypeList
              .filter(m => m?.MediumGroupDiv === '01');
          }

          if (PlessViewUtilsSub.isEmptyArray(result)) {
            errPCodes.push(item.PCode);
          }
        } catch (err) {
          errPCodes.push(item.PCode);
        }
      }

      if (errPCodes.length > 0) {
        let errCode = '';
        if (selectedMediumTypeList.MediumGroupDiv === '03'){
          errCode = 'E0648';
        } else {
          errCode = 'E0649';
        }

        this.dialogService.openAlertGetMessage(errCode, [errPCodes.join(', ')]);
        return false;
      }
    }

    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.bundleCatalogGuideStandardName)) {
      registPlanVO.bundleCatalogRoundId = this.kymw1300Model.BundleCatalogRoundId;
    }
    // 07. 商品選定確認API呼び出し
    this.checkRegistPlanService.execute(this.kymw1300Model, checkregistPlanVO,
      (data: any) => this.checkRegistPlanServiceSuccessFunc(data, registPlanVO));

    // 「選定」クリックフラグ初期化
    this.kymw1300Model.senteiFlg = '1';
  }

  private execGetPlanTargetListAsync(model: KYMW1300Model, vo: KYMW1300GetPlanTargetListModel, list: PlanTargetList): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        // 第4引数の successFunc が呼ばれたら resolve
        this.getPlanTargetListService.execute(model, vo, list, (data: any) => {
          resolve(data);
        });
      } catch (e) {
        // execute 内で同期例外が出た場合
        reject(e);
      }
    });
  }

  private execGetDeletePlanGoodsInfoAsync(vo: GetDeletePlanGoodsInfoModel): Promise<any> {
    return new Promise((resolve, reject) => {
      try {
        // 第3引数の successFunc が呼ばれたら resolve
        this.getDeletePlanGoodsInfoService.execute(null, vo, (data: any) => {
          resolve(data);
        });
      } catch (e) {
        // execute 内で同期例外が出た場合
        reject(e);
      }
    });
  }

  /**
   * バンドルミックスマッチ設定画面 Output時
   *
   * @param {KYMW1308OutputModel} outputVO
   * @memberof KYMW1300Component
   */
  public setKYMW1308Parameter(outputVO: KYMW1308OutputModel): void {
    // 検索フラグのチェック
    if (this.kymw1300_03.selectedModel.searchFlg) {                             // 「true：検索済」の場合
      // 05. 選定済一覧取得APIリクエストVO初期化処理
      const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.kymw1300Model.setGetSelectedListVO(true);
      getSelectedListVO.searchPCode = this.kymw1300Model.getSelectedPCode();

      // 検索条件を保持しておき次回検索がページングの場合に利用する
      this.kymw1300Model.lastTimeGetSelectedListVO = getSelectedListVO;

      // 05. 選定済一覧取得API呼び出し
      this.getSelectedListService.execute(this.kymw1300Model, getSelectedListVO,
        (data: any) => this.getSelectedListServiceSuccessFunc(data, getSelectedListVO));
    }
  }

  /**
   * Ｗ掲載設定画面 Output時
   *
   * @memberof KYMW1300Component
   */
  public setKYMW1310Parameter(): void {
    // 05. 選定済一覧取得APIリクエストVO初期化処理
    const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.kymw1300Model.setGetSelectedListVO(true);
    getSelectedListVO.searchPCode = this.kymw1300Model.getSelectedPCode();

    // 検索条件を保持しておき次回検索がページングの場合に利用する
    this.kymw1300Model.lastTimeGetSelectedListVO = getSelectedListVO;

    // 05. 選定済一覧取得API呼び出し
    this.getSelectedListService.execute(this.kymw1300Model, getSelectedListVO,
      (data: any) => this.getSelectedListServiceSuccessFunc(data, getSelectedListVO));
  }

  /**
   * セット企画設定画面 Output時
   *
   * @param {KYMW1312OutputModel} outputVO
   * @memberof KYMW1300Component
   */
  public setKYMW1312Parameter(outputVO: KYMW1312OutputModel): void {
    // 検索フラグのチェック
    if (this.kymw1300_03.selectedModel.searchFlg) {                            // 「true：検索済」の場合

      // 05. 選定済一覧取得APIリクエストVO初期化処理
      const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.kymw1300Model.setGetSelectedListVO(true);
      getSelectedListVO.searchPCode = this.kymw1300Model.getSelectedPCode();

      // 検索条件を保持しておき次回検索がページングの場合に利用する
      this.kymw1300Model.lastTimeGetSelectedListVO = getSelectedListVO;

      // 05. 選定済一覧取得API呼び出し
      this.getSelectedListService.execute(this.kymw1300Model, getSelectedListVO,
        (data: any) => this.getSelectedListServiceSuccessFunc(data, getSelectedListVO));
    }
  }

  /**
   * 企画連絡承認画面 Output時
   *
   * @param {KYMW1317OutputModel} outputVO
   * @memberof KYMW1300Component
   */
  public setKYMW1317Parameter(outputVO: KYMW1317OutputModel): void {

    if (!outputVO.isExecuteApproval) return;

    // 選定済一覧取得APIリクエストVO初期化処理
    const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.kymw1300Model.setGetSelectedListVO(true);
    getSelectedListVO.searchPCode = this.kymw1300Model.getSelectedPCode();

    // 検索条件を保持しておき次回検索がページングの場合に利用する
    this.kymw1300Model.lastTimeGetSelectedListVO = getSelectedListVO;

    // 05. 選定済一覧取得API呼び出し
    this.getSelectedListService.execute(this.kymw1300Model, getSelectedListVO,
      (data: any) => this.getSelectedListServiceSuccessFunc(data, getSelectedListVO));
  }

  // ロック処理 START
  /**
   * ロック取得
   *
   * @param orderCode 受注コード
   * @param mediumType 媒体区分
   * @param pCode Ｐコード
   * @param isKYMW0800 実績履歴フラグ
   */
  public registLockInfo(orderCode: string, mediumType: string, pCode: string, isKYMW0800 = false): void {

    // ロック情報を設定する
    this.kymw1300Model.lockOrderCode = orderCode;
    this.kymw1300Model.lockMediumType = mediumType;

    if (isKYMW0800) {
      this.kymw1300Model.lockPCode_KYMW0800 = pCode;
    } else {
      this.kymw1300Model.lockPCode = pCode;
    }
  }

  /**
   * ロック解除
   *
   * @param isKYMW0800 実績履歴フラグ
   */
  public deleteLockInfo(isKYMW0800 = false): void {

    if (isKYMW0800) {
      this.kymw1300Model.lockPCode_KYMW0800 = <string>'';

      if (PlessViewUtilsSub.isEmpty(this.kymw1300Model.lockPCode)) {
        this.kymw1300Model.lockOrderCode = <string>'';
        this.kymw1300Model.lockMediumType = <string>'';
      }
    } else {
      this.kymw1300Model.lockPCode = <string>'';

      if (PlessViewUtilsSub.isEmpty(this.kymw1300Model.lockPCode_KYMW0800)) {
        this.kymw1300Model.lockOrderCode = <string>'';
        this.kymw1300Model.lockMediumType = <string>'';
      }
    }
  }


  /**
   *
   *
   * @param {string} target 画面ID
   * @memberof KYMW1300Component
   */
  public lockOKFunc_Reflesh(target: string): void {
    const mediumType: string = this.kymw1300_03.dg_SelectedItemList.selectedItems[0].MediumType;
    const pCode: string = this.kymw1300_03.dg_SelectedItemList.selectedItems[0].PCode;

    // 画面起動状況のチェック
    if (this.isOpened('KYMW1310')) {                                             // Ｗ掲載設定画面が起動中の場合、
      // ロック取得処理
      this.registLockInfo(this.kymw1300Model.orderCode, mediumType, pCode, false);
    }

    // 画面起動状況のチェック
    if (this.isOpened('KYMW0800')) {                                            // 実績履歴画面が起動中の場合
      // ロック取得処理
      this.registLockInfo(this.kymw1300Model.orderCode, mediumType, pCode, true);
    }

    // 子画面再表示処理
    this.refleshChildWindow(target, true);
  }

  /**
   *
   *
   * @param {string} target 画面ID
   * @memberof KYMW1300Component
   */
  public lockErrFunc_Reflesh(target: string): void {
    // 子画面再表示処理
    this.refleshChildWindow(target, false);
  }

  /**
   * 実績履歴画面起動(ロック取得成功時)
   *
   * @param {KYMW0800InputModel} vo 実績履歴画面InputVO
   * @memberof KYMW1300Component
   */
  public lockOkFunc_KYMW0800(vo: KYMW0800InputModel): void {
    this.registLockInfo(vo.orderCode, vo.mediumType, vo.pCodeList[0].PCode, true);

    // 実績履歴画面(モーダレス)を表示する。
    this.kymw0800ComponentRef =
      this.dialogService.openModelessSub(this, KYMW0800Component,
        this.viewContainerRef, this.kymw0800ComponentRef, vo, 0, '', true);
    if (this.kymw0800ComponentRef != null) {
      this.kymw0800cmp =
        this.kymw0800ComponentRef.instance as KYMW0800Component;
      this.kymw0800cmp.setInterfaceParam(vo);
      this.kymw0800cmp.parent = this;

      this.kymw0800cmp.setKYMW0800Parameter
        = (outputVO: KYMW0800OutputModel) => this.setKYMW0800Parameter(outputVO);

      // ウィンドウが閉じられる際の処理
      this.kymw0800cmp.closeFunction = () => {
        this.kymw0800ComponentRef.destroy();
        this.kymw0800cmp = null;
        this.checkLockChildClose();
      };
    }
  }

  /**
   * 実績履歴画面起動(ロック取得失敗時)
   *
   * @param {KYMW0800InputModel} vo 実績履歴画面InputVO
   * @memberof KYMW1300Component
   */
  public lockErrFunc_KYMW0800(vo: KYMW0800InputModel, result: any): void {
    // ロック取得に失敗した時は実績履歴画面の活性制御の為、画面名を変更する
    vo.funcID = 'KYMW1300L';
    // 実績履歴画面(モーダレス)を表示する。
    this.kymw0800ComponentRef =
      this.dialogService.openModelessSub(this, KYMW0800Component,
        this.viewContainerRef, this.kymw0800ComponentRef, vo, 0, '', true);
    if (this.kymw0800ComponentRef != null) {
      this.kymw0800cmp =
        this.kymw0800ComponentRef.instance as KYMW0800Component;
      this.kymw0800cmp.setInterfaceParam(vo);
      this.kymw0800cmp.parent = this;

      this.kymw0800cmp.setKYMW0800Parameter
        = (outputVO: KYMW0800OutputModel) => this.setKYMW0800Parameter(outputVO);

      // ウィンドウが閉じられる際の処理
      this.kymw0800cmp.closeFunction = () => {
        this.kymw0800ComponentRef.destroy();
        this.kymw0800cmp = null;
        this.checkLockChildClose();
      };
    }
  }

  /**
   * 商品企画メンテナンス画面画面起動(ロック取得成功時)
   *
   * @param {KYMW0900InputModel} vo 商品企画メンテナンス画面InputVO
   * @memberof KYMW1300Component
   */
  public lockOkFunc_KYMW0900(vo: KYMW0900InputModel): void {
    // 商品企画メンテナンス画面InputVO初期化
    vo.lockInfo = '0';

    // 束ね企画回名が選択されている場合束ね企画の終了受注コードを受け渡す
    if(!PlessViewUtilsSub.isEmpty(this.kymw1300Model.bundleCatalogGuideStandardName)) {
      vo.bundleCatalogOrderCode = this.kymw1300Model.endOrderCode;
    }

    // 商品企画メンテナンス画面画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW0900Component);
    const instance = componentRef.componentInstance as KYMW0900Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0900Parameter =
      (kymw0900OutputVO: KYMW0900OutputModel) => this.setKYMW0900Parameter(kymw0900OutputVO);
    instance.closeFunction = (kymw0900OutputVO: KYMW0900OutputModel) => {
      // 商品企画修正_終了時ロック解除処理
      this.checkLockKYMW0900Close();
      componentRef.close();
    };
  }

  /**
   * 商品企画メンテナンス画面画面起動(ロック取得失敗時)
   *
   * @param {KYMW0900InputModel} vo 商品企画メンテナンス画面画面InputVO
   * @memberof KYMW1300Component
   */
  public lockErrFunc_KYMW0900(vo: KYMW0900InputModel, result: any): void {
    // 商品企画メンテナンス画面InputVO初期化
    vo.lockInfo = '1';

    // 束ね企画回名が選択されている場合束ね企画の終了受注コードを受け渡す
    if(!PlessViewUtilsSub.isEmpty(this.kymw1300Model.bundleCatalogGuideStandardName)) {
      vo.bundleCatalogOrderCode = this.kymw1300Model.endOrderCode;
    }

    // 商品企画メンテナンス画面画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW0900Component);
    const instance = componentRef.componentInstance as KYMW0900Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW0900Parameter =
      (kymw0900OutputVO: KYMW0900OutputModel) => this.setKYMW0900Parameter(kymw0900OutputVO);
    instance.closeFunction = (kymw0900OutputVO: KYMW0900OutputModel) => {
      componentRef.close();
    };
    let UserName = '';
    if (result.result.obj.UnlockedInfo.Catalog[0] != null) {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserName) + ']';
    } else if (result.result.obj.UnlockedInfo.Page[0] != null) {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserName) + ']';
    } else {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[0].UserName) + ']';
    }
    this.dialogService.openAlertGetMessage('E0141', [UserName]);
  }

  /**
   * Ｗ掲載設定画面起動(ロック取得成功時)
   *
   * @param {KYMW1310InputModel} vo Ｗ掲載設定画面InputVO
   * @memberof KYMW1300Component
   */
  public lockOkFunc_KYMW1310(vo: KYMW1310InputModel): void {
    const mediumType: string = this.kymw1300_03.dg_SelectedItemList.selectedItems[0].MediumType;

    this.registLockInfo(vo.orderCode, mediumType, vo.pCode);

    // Ｗ掲載設定画面(モーダレス)を表示する。
    this.kymw1310ComponentRef = this.dialogService.openModelessSub(this, KYMW1310Component,
      this.viewContainerRef, this.kymw1310ComponentRef, vo, 0, '', true);
    if (this.kymw1310ComponentRef != null) {
      this.kymw1310cmp = this.kymw1310ComponentRef.instance as KYMW1310Component;
      this.kymw1310cmp.setInterfaceParam(vo);
      this.kymw1310cmp.setKYMW1310Parameter = () => this.setKYMW1310Parameter();
      this.kymw1310cmp.parent = this;

      // ウィンドウが閉じられる際の処理
      this.kymw1310cmp.closeFunction = () => {
        this.kymw1310ComponentRef.destroy();
        this.kymw1310cmp = null;
        this.checkLockChildClose();
      };
    }
  }

  /**
   * Ｗ掲載設定画面起動(ロック取得失敗時)
   *
   * @param {KYMW1310InputModel} vo Ｗ掲載設定画面InputVO
   * @memberof KYMW1300Component
   */
  public lockErrFunc_KYMW1310(vo: KYMW1310InputModel, result: any): void {
    vo.editLock = false;

    // Ｗ掲載設定画面(モーダレス)を表示する。
    this.kymw1310ComponentRef = this.dialogService.openModelessSub(this, KYMW1310Component,
      this.viewContainerRef, this.kymw1310ComponentRef, vo, 0, 'true', true);
    if (this.kymw1310ComponentRef != null) {
      this.kymw1310cmp = this.kymw1310ComponentRef.instance as KYMW1310Component;
      this.kymw1310cmp.setInterfaceParam(vo);
      this.kymw1310cmp.setKYMW1310Parameter = () => this.setKYMW1310Parameter();
      this.kymw1310cmp.parent = this;

      // ウィンドウが閉じられる際の処理
      this.kymw1310cmp.closeFunction = () => {
        this.kymw1310ComponentRef.destroy();
        this.kymw1310cmp = null;
        this.checkLockChildClose();
      };
    }
  }

  /**
   * 企画連絡承認画面起動(ロック取得成功時)
   *
   * @param {KYMW1317InputModel} vo 企画連絡承認画面InputVO
   * @memberof KYMW1300Component
   */
  public lockOkFunc_KYMW1317(vo: KYMW1317InputModel): void {
    // 企画連絡承認画面InputVO初期化
    vo.lockInfo = '0';
    // 企画連絡承認画面画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW1317Component);
    const instance = componentRef.componentInstance as KYMW1317Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW1317Parameter =
      (kymw1317OutputVO: KYMW1317OutputModel) => this.setKYMW1317Parameter(kymw1317OutputVO);
    instance.closeFunction = (kymw1317OutputVO: KYMW1317OutputModel) => {
      // 商品企画修正_終了時ロック解除処理
      this.checkLockKYMW1317Close();
      componentRef.close();
    };
  }

  /**
   * 企画連絡承認画面起動(ロック取得失敗時)
   *
   * @param {KYMW1317InputModel} vo 企画連絡承認画面InputVO
   * @memberof KYMW1300Component
   */
  public lockErrFunc_KYMW1317(vo: KYMW1317InputModel, result: any): void {
    // 企画連絡承認画面InputVO初期化
    vo.lockInfo = '1';

    // 企画連絡承認画面(モーダル)を表示する。
    const componentRef = this.dialogService.openModal(KYMW1317Component);
    const instance = componentRef.componentInstance as KYMW1317Component;
    instance.parent = this;
    instance.setInterfaceParam(vo);
    instance.setKYMW1317Parameter =
      (kymw1317OutputVO: KYMW1317OutputModel) => this.setKYMW1317Parameter(kymw1317OutputVO);
    instance.closeFunction = (kymw1317OutputVO: KYMW1317OutputModel) => {
      componentRef.close();
    };
    let UserName = '';
    if (result.result.obj.UnlockedInfo.Catalog[0] != null) {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Catalog[0].UserName) + ']';
    } else if (result.result.obj.UnlockedInfo.Page[0] != null) {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.Page[0].UserName) + ']';
    } else {
      UserName = '[' + PlessViewUtilsSub.trim(result.result.obj.UnlockedInfo.PlanGoods[0].UserName) + ']';
    }
    this.dialogService.openAlertGetMessage('E0141', [UserName]);
  }

  /**
   * 子画面close時の排他RELEASE
   *
   * @returns {void}
   * @memberof KYMW1300Component
   */
  public checkLockChildClose(): void {
    // 実績履歴以外が開いている場合,処理を抜ける（実績履歴が開いていない場合はlockPCode_KYMW0800をクリア)
    // 個別設定画面、計画数設定画面、Ｗ掲載設定画面の起動状況のチェック
    if (this.isOpened('KYMW1310')) {                                             // Ｗ掲載設定画面が起動済みの場合

      // 実績履歴画面の起動状況のチェック
      if (!this.isOpened('KYMW0800')) {                                         // 起動していない場合
        // ロック解除処理
        this.deleteLockInfo(true);
      }

      // 処理復帰
      return;
    }
    // 実績履歴のみが開いていてlockPCode_KYMW0800が存在する場合、lockPCodeをクリアする
    // 排他情報・Ｐコード・KYMW0800画面のチェック
    // 実績履歴画面の起動状況のチェック
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.lockPCode_KYMW0800)       // 指定あり、
      && this.isOpened('KYMW0800')) {                                            // 起動済みの場合

      // ロック解除処理
      this.deleteLockInfo();

      // 処理復帰
      return;
    }

    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.lockPCode)) {
      // ロック情報のリリースを行う
      this.LockUtilForPlanGoods('RELEASE',
        this.kymw1300Model.lockOrderCode, this.kymw1300Model.lockMediumType, this.kymw1300Model.lockPCode,
        null, null,
        null, null,
        false);

      // ロック解除処理
      this.deleteLockInfo();
    }

    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.lockPCode_KYMW0800)) {
      // ロック情報のリリースを行う
      this.LockUtilForPlanGoods('RELEASE',
        this.kymw1300Model.lockOrderCode, this.kymw1300Model.lockMediumType, this.kymw1300Model.lockPCode_KYMW0800,
        null, null,
        null, null,
        false);

      // ロック解除処理
      this.deleteLockInfo(true);
    }
  }

  /**
   * 商品企画修正_終了時ロック解除処理
   */
  public checkLockKYMW0900Close(): void {
    if (this.kymw1300_03.dg_SelectedItemList.selection.row === -1) {
      return;
    }

    const pCode: string = this.kymw1300_03.dg_SelectedItemList.selectedItems[0].PCode;
    const mediumType: string = this.kymw1300_03.dg_SelectedItemList.selectedItems[0].MediumType;

    // 排他情報・Ｐコード、選択行Ｐコードのチェック
    if (PlessViewUtilsSub.isEmpty(this.kymw1300Model.lockPCode) ||              // 未指定、
      this.kymw1300Model.lockPCode !== pCode) {                                 // 異なる場合

      // ロック情報のリリースを行う
      this.LockUtilForPlanGoods('RELEASE',
        this.kymw1300Model.orderCode, mediumType, pCode,
        null, null,
        null, null,
        false);
    }
  }

  /**
   * 企画連絡承認画面_終了時ロック解除処理
   */
  public checkLockKYMW1317Close(): void {
    if (this.kymw1300_03.dg_SelectedItemList.selection.row === -1) {
      return;
    }

    const pCode: string = this.kymw1300_03.dg_SelectedItemList.selectedItems[0].PCode;
    const mediumType: string = this.kymw1300_03.dg_SelectedItemList.selectedItems[0].MediumType;

    // 排他情報・Ｐコード、選択行Ｐコードのチェック
    if (PlessViewUtilsSub.isEmpty(this.kymw1300Model.lockPCode) ||              // 未指定、
      this.kymw1300Model.lockPCode !== pCode) {                                 // 異なる場合

      // ロック情報のリリースを行う
      this.LockUtilForPlanGoods('RELEASE',
        this.kymw1300Model.orderCode, mediumType, pCode,
        null, null,
        null, null,
        false);
    }
  }

  /**
   * サーバ取得データを処理ログに表示する
   *
   * @param {*} serverData サーバ取得データ
   * @param {string} dataDiv データ区分
   * @memberof KYMW1300Component
   */
  public updateResult(serverData: any, dataDiv: string): void {
    const componentRef = this.dialogService.openModal(KYMW0D00Component);
    const instance = componentRef.componentInstance as KYMW0D00Component;
    instance.parent = this;
    // VOに値を設定
    const inpVO: KYMW0D00InputModel = new KYMW0D00InputModel();
    inpVO.dispId = 'KYMW1300';                                                  // 画面ＩＤ
    inpVO.dataDiv = dataDiv;                                                    // データ区分
    inpVO.normalNum = serverData.NormalNum;                                     // 正常件数
    inpVO.attentionNum = serverData.AttentionNum;                               // 注意件数
    inpVO.abnormalNum = serverData.AbnormalNum;                                 // 異常件数
    inpVO.updateNum = serverData.UpdateNum;                                     // ＤＢ更新件数
    inpVO.manageNum = serverData.ManageNum;                                     // 処理件数
    instance.setInterfaceParam(inpVO);
    instance.closeFunction = () => {
      componentRef.close();
    };
  }

  /**
   * 01. 企画管理情報取得API成功処理
   *
   * @param {*} data APIレスポンス
   * @param {*} isBundle 束ね企画入力時フラグ
   * @memberof KYMW1300Component
   */
  public getCatalogInfoServiceSuccessFunc(data: CatalogInfoModel, isBundle: boolean): void {
    // 企画管理情報取得APIレスポンスを保持
    this.kymw1300Model.updateCatalogInfo(data, this.txt_OrderCode.isValidOrderCode(), isBundle);

    // 06. 予算・計画数一覧取得APIリクエストVO初期化処理
    const getPlanNumListVO: KYMW1300GetPlanNumListModel = this.kymw1300Model.setGetPlanNumListVO();

    // 06. 予算・計画数一覧取得API呼び出し
    this.getPlanNumListService.execute(this.kymw1300Model, getPlanNumListVO,
      (res: any) => this.getPlanNumListServiceSuccessFunc(res, getPlanNumListVO));
  }

  /**
   * 04. 選定候補一覧(候補セット)取得API成功処理
   *
   * @param {*} data APIレスポンス
   * @param {KYMW1300GetPlanTargetListModel} vo 選定候補一覧取得APIリクエストVO
   * @memberof KYMW1300Component
   */
  public getPlanTargetListServiceSuccessFunc(data: CommonTargetModel, vo: KYMW1300GetPlanTargetListModel): void {
    // 選定候補一覧(候補セット)取得APIレスポンスを保持
    this.kymw1300_02.targetSetModel.updateSelectTargetList(data, vo);
  }

  /**
   * 05. 選定済一覧取得API成功処理
   *
   * @param {*} data APIレスポンス
   * @param {KYMW1300GetSearchSelectedListModel} vo 選定済一覧取得APIリクエストVO
   * @memberof KYMW1300Component
   */
  public getSelectedListServiceSuccessFunc(data: SelectedGoodsListModel, vo: KYMW1300GetSearchSelectedListModel): void {
    // 選定済一覧取得APIレスポンスを保持
    this.kymw1300_03.selectedModel.updateSelectedList(data, vo);

    if (!PlessViewUtilsSub.isEmpty(vo.searchPCode)) {                           // 指定ありの場合
      // 行選択・スクロール処理
      this.kymw1300_03.selectRowSelected(
        vo.searchPCode,
        true,
        vo,
        (param: KYMW1300GetSearchSelectedListModel) => {
          this.getSelectedListServiceSuccessNextFunc(param);
        });
    } else {
      this.getSelectedListServiceSuccessNextFunc(vo);
    }
  }

  /**
   * 選定済一覧取得API成功時後続処理
   *
   * @param {KYMW1300GetSearchSelectedListModel} vo
   * @memberof KYMW1300Component
   */
  public getSelectedListServiceSuccessNextFunc(vo: KYMW1300GetSearchSelectedListModel): void {
    // 06. 予算・計画数一覧取得APIリクエストVO初期化処理
    const getPlanNumListVO: KYMW1300GetPlanNumListModel = this.kymw1300Model.setGetPlanNumListVO();
    getPlanNumListVO.focusFlg = vo.focusFlg;

    // 06. 予算・計画数一覧取得API呼び出し
    this.getPlanNumListService.execute(this.kymw1300Model, getPlanNumListVO,
      (res: any) => {
        this.getPlanNumListServiceSuccessFunc(res, getPlanNumListVO);
        // 『予算計画実績表』画面が開いていない場合
        if(!this.isOpened('KYMW1307')){
          this.refleshTargetWindow();
        }
      }
    );
  }

  /**
   * 06. 予算・計画数一覧取得API成功処理
   *
   * @param {*} data APIレスポンス
   * @param {KYMW1300GetPlanNumListModel} vo 予算・計画数一覧取得APIリクエストVO
   * @memberof KYMW1300Component
   */
  public getPlanNumListServiceSuccessFunc(data: PlanNumModel, vo: KYMW1300GetPlanNumListModel): void {
    // 計画数一覧取得APIレスポンスを保持
    this.kymw1300_03.selectedModel.updatePlanNumList(data);
  }

  /**
   * 07. 商品選定確認API成功処理
   *
   * @param {*} data APIレスポンス
   * @param {KYMW1300RegistPlanModel} vo 商品選定確認APIリクエストVO
   * @memberof KYMW1300Component
   */
  public checkRegistPlanServiceSuccessFunc(data: any, vo: KYMW1300RegistPlanModel): void {
    let errList: Array<any> = new Array<any>();

    // APIレスポンスのチェック
    if (data !== null && data.length > 0) {                           // 該当データありの場合
      errList = data;
    }
    // 選定処理確認メッセージ表示処理
    this.showErrMesRegistPlan(vo, errList);
  }

  /**
   * 08. 商品選定API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public registPlanServiceSuccessFunc(data: any): void {
    let arrList: Array<any> = new Array<any>();
    const replaceArray: Array<Array<string>> = new Array<Array<string>>();
    const msgIdList: Array<any> = new Array<any>();


    // エラーリストのチェック
    if (!PlessViewUtilsSub.isEmptyArray(data.CheckErrorList)) {                 // エラーありの場合
      arrList = data.CheckErrorList;

      // エラーメッセージ表示
      for (const errData of arrList) {                                          // エラーリスト要素数分ループ
        const replacetemp = new Array<string>();
        replacetemp.push(errData.Parameter1);
        replacetemp.push(errData.Parameter2);
        replacetemp.push(errData.Parameter3);
        replacetemp.push(errData.Parameter4);
        replacetemp.push(errData.Parameter5);
        replaceArray.push(replacetemp);
        msgIdList.push(errData.MessageID);
      }
      const success = data.PCodeList != null && data.PCodeList.PCode.length > 0; //選定Pコードがあるか
      // エラーメッセージ表示
      this.dialogMMService.openAlertGetMessage(msgIdList, replaceArray, success,() => { });
    }

    if (data.PCodeList == null || !data.PCodeList.PCode.length) {            // 選定解除Ｐコードなしの場合
      // 処理復帰
      return;
    }

    // 商品選定したＰコードリストの保持
    arrList = data.PCodeList.PCode;

    const searchOrderCode =  PlessViewUtilsSub.isEmpty(this.kymw1300Model.orderCode) ? this.kymw1300Model.startOrderCode: this.kymw1300Model.orderCode;

    if (!PlessViewUtilsSub.isEmpty(searchOrderCode)) {
      // ステータスの更新
      this.kymw1300_02.targetSetModel.setStatus_Regist(arrList);

      // 選定候補一覧の背景色設定処理
      this.kymw1300_02.setColorPattern(this.kymw1300_02.dg_SelectTargetList);

      this.kymw1300_03.setDispMode('1');
      this.kymw1300_03.selectedModel.accessClassCode = data.ClassCode;
      this.kymw1300_03.selectedModel.accessMiddleClassCode = data.MiddleClassCode;
      this.kymw1300_03.selectedModel.accessSmallClassCode = data.SmallClassCode;
      this.kymw1300_03.selectedModel.orderNumQuotaCode = this.kymw1300_02.cmb_OrderNumQuota.selectedOrderNumQuotaCode;

      this.kymw1300_03.cmb_ClassCode.setClassCode(data.ClassCode);
      this.kymw1300_03.cmb_MiddleClassCode.setMiddleClassCode(data.MiddleClassCode);
      this.kymw1300_03.cmb_SmallClassCode.setSmallClassCode(data.SmallClassCode);
      if (this.kymw1300Model.isGroupNormalOrStock()) {
        this.kymw1300_03.cmb_OrderNumQuota_Selected.setOrderNumQuotaCode(this.kymw1300_02.cmb_OrderNumQuota.selectedOrderNumQuotaCode);
      } else {
        // 選定媒体の媒体グループ区分が「01: 通常媒体」「10: 在庫限定」以外の場合は初期表示空白
        this.kymw1300_03.cmb_OrderNumQuota_Selected.setOrderNumQuotaCode('');
      }

      // データグリッド行の選択解除
      this.kymw1300_03.dg_SelectedItemList.select(-1, -1);

      // 05. 選定済一覧取得APIリクエストVO初期化処理
      const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.kymw1300Model.setGetSelectedListVO(false);
      getSelectedListVO.middleClassCode = data.MiddleClassCode;
      getSelectedListVO.smallClassCode = data.SmallClassCode;
      getSelectedListVO.focusFlg = '3';

      // 検索条件を保持しておき次回検索がページングの場合に利用する
      this.kymw1300Model.lastTimeGetSelectedListVO = getSelectedListVO;

      // 05. 選定済一覧取得API呼び出し
      this.getSelectedListService.execute(this.kymw1300Model, getSelectedListVO,
        (res: any) => this.getSelectedListServiceSuccessFunc(res, getSelectedListVO));
    }
  }

  /**
   * 09. 選定解除確認API成功処理
   *
   * @param {*} data APIレスポンス
   * @param {KYMW1300DeletePlanModel} vo
   * @memberof KYMW1300Component
   */
  public checkDeletePlanServiceSuccessFunc(data: any, vo: KYMW1300DeletePlanModel): void {
    let errList: Array<any> = new Array<any>();

    // APIレスポンスのチェック
    if (data !== null) {                             // 該当データありの場合
      errList = data;
    }

    // 選定解除処理確認メッセージ表示処理
    this.showErrMesDeletePlan(vo, errList);
  }

  /**
   * 10. 選定解除API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public deletePlanServiceSuccessFunc(data: any): void {
    let arrList: Array<any> = new Array<any>();

    // 受注コード指定選定解除画面表示フラグが"1"の場合
    // 受注コード指定選定解除リクエスト用VOを作成し、受注コード指定選定解除モーダル画面を呼び出す
    if (data.OrderCodeSpecifyDeletePlanViewFlg == 1) {
      const kymw1318InputVO: KYMW1318InputModel = this.kymw1300Model.setKYMW1318InputVO(data.OrderCodeSpecifyDeletePlanList);

      // 受注コード指定選定解除モーダル画面(モーダレス)を表示する。
      this.kymw1318ComponentRef =
        this.dialogService.openModelessSub(this.kymw1300Model.kymw1300Component, KYMW1318Component,
          this.kymw1300Model.kymw1300Component.viewContainerRef, this.kymw1318ComponentRef, kymw1318InputVO, 0, '', true);
      if (this.kymw1318ComponentRef != null) {
        this.kymw1318cmp = this.kymw1318ComponentRef.instance as KYMW1318Component;
        this.kymw1318cmp.parent = this.kymw1300Model.kymw1300Component;
        this.kymw1318cmp.setInterfaceParam(kymw1318InputVO);

        // ウィンドウが閉じられる際の処理
        this.kymw1318cmp.closeFunction = () => {
          this.kymw1318ComponentRef.destroy();

          // 選定済一覧取得APIリクエストVO初期化処理
          const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.kymw1300Model.setGetSelectedListVO(true);
          getSelectedListVO.focusFlg = '0';
          
          // 検索条件を保持しておき次回検索がページングの場合に利用する
          this.kymw1300Model.lastTimeGetSelectedListVO = getSelectedListVO;

          // 選定済一覧取得API呼び出し
          this.getSelectedListService.execute(this.kymw1300Model, getSelectedListVO,
            (res: any) => this.getSelectedListServiceSuccessFunc(res, getSelectedListVO));
        };
      }
    }

    // 選定解除したＰコードリストのチェック
    if (PlessViewUtilsSub.isEmptyArray(data.PCodeList)             // 選定解除Ｐコードなしの場合
      || PlessViewUtilsSub.isEmptyArray(data.PCodeList.PCode)) {
      // 処理復帰
      return;
    }
    if (data.PCodeList == null || !data.PCodeList.PCode.length) {  // 選定解除Ｐコードなしの場合
      // 処理復帰
      return;
    }

    // 選定解除したＰコードリストの保持
    arrList = data.PCodeList.PCode;

    // ステータスの更新
    this.kymw1300_02.targetSetModel.setStatus_Delete(arrList);

    // 選定候補一覧の背景色設定処理
    this.kymw1300_02.setColorPattern(this.kymw1300_02.dg_SelectTargetList);

    // 05. 選定済一覧取得APIリクエストVO初期化処理
    const getSelectedListVO: KYMW1300GetSearchSelectedListModel = this.kymw1300Model.setGetSelectedListVO(true);
    getSelectedListVO.focusFlg = '3';

    // 検索条件を保持しておき次回検索がページングの場合に利用する
    this.kymw1300Model.lastTimeGetSelectedListVO = getSelectedListVO;

    // 05. 選定済一覧取得API呼び出し
    this.getSelectedListService.execute(this.kymw1300Model, getSelectedListVO,
      (res: any) => this.getSelectedListServiceSuccessFunc(res, getSelectedListVO));
  }

  /**
   * 11. 次回案内自動設定API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public updateNextGuideAutoServiceSuccessFunc(data: any): void {
    // APIレスポンスのチェック
    // 排他チェックでエラーの場合はnullが戻ってくる可能性がある
    if (data == null) {                                                         // 対象Ｐコードなしの場合
      // 処理復帰
      return;
    }

    let resultList: Array<any> = new Array<any>();
    resultList = data;

    // 選定済リスト
    const selectedList: Array<any> = this.kymw1300_03.selectedModel.selectedList;

    // 次回案内自動設定処理
    for (const resData of resultList) {                                         // レスポンス要素数分ループ

      // 次回案内自動設定処理
      for (let i = Number(0); i < selectedList.length; i++) {           // 選定済リスト要素数分ループ

        // Ｐコードの比較
        if (selectedList[i].PCode === resData.PCode) {                    // 同一Ｐコードの場合

          // 次回案内の自動設定の結果をセット
          selectedList[i].NextGuideIB = resData.NextGuideIB;
          selectedList[i].NextGuideTO = resData.NextGuideTO;
          selectedList[i].NextGuideGU = resData.NextGuideGU;
          selectedList[i].NextGuideTI = resData.NextGuideTI;
          selectedList[i].NextGuideSA = resData.NextGuideSA;
          selectedList[i].NextGuideTK = resData.NextGuideTK;
          selectedList[i].NextGuideNA = resData.NextGuideNA;
          selectedList[i].NextGuideNI = resData.NextGuideNI;

          // 次回案内のチェック結果をクリア
          selectedList[i].NextGuideCheckGU = '0';
          selectedList[i].NextGuideCheckIB = '0';
          selectedList[i].NextGuideCheckNA = '0';
          selectedList[i].NextGuideCheckNI = '0';
          selectedList[i].NextGuideCheckSA = '0';
          selectedList[i].NextGuideCheckTI = '0';
          selectedList[i].NextGuideCheckTK = '0';
          selectedList[i].NextGuideCheckTO = '0';

          // ループ中断
          break;
        }
      }
    }

    // フォーカス設定
    this.kymw1300_03.dg_SelectedItemList.focus();
  }

  /**
   * 12. 次回案内一括設定API成功処理
   *
   * @param {*} data APIレスポンス
   * @param {KYMW1300GetSearchSelectedListModel} vo
   * @memberof KYMW1300Component
   */
  public updateNextGuideLumpServiceSuccessFunc(data: any, vo: KYMW1300GetSearchSelectedListModel): void {
    // 選定済一覧の反映処理
    this.kymw1300_03.selectedModel.updateSelectedList(data, vo);

    // 子画面の再表示を行う
    this.refleshTargetWindow();

    // 06. 予算・計画数一覧取得APIリクエストVO初期化処理
    const getPlanNumListVO: KYMW1300GetPlanNumListModel = this.kymw1300Model.setGetPlanNumListVO();
    getPlanNumListVO.focusFlg = '4';

    // 06. 予算・計画数一覧取得API呼び出し
    this.getPlanNumListService.execute(this.kymw1300Model, getPlanNumListVO,
      (res: any) => this.getPlanNumListServiceSuccessFunc(res, getPlanNumListVO));
  }

  /**
   * 14. 企画ロック情報削除API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public deleteLockInfoCatalogServiceSuccessFunc(data: any): void {
    // ロック解除処理
    this.deleteLockInfo();
  }

  /**
   * 15. 選定済一覧TXT出力API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public outputSelectedListServiceSuccessFunc(data: any): void {
    // ファイル名の設定
    const fileName = '選定済データ_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD') + '.TXT';

    this.fileDownloadConfirmService.show(data.FileName, fileName);
  }

  /**
   * 16. バンドルミックスマッチリスト出力API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public outputBundleMixMatchListServiceSuccessFunc(data: any): void {
    // ファイル名の設定
    const fileName = 'バンドルミックスマッチリスト_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD') + '.CSV';

    // ファイルダウンロード
    this.fileDownloadConfirmService.show(data.FileName, fileName);
  }

  /**
   * 17. 仕様確認表出力API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public outputSpecConfirmListServiceSuccessFunc(data: any): void {
    // ファイル名の設定
    const fileName = '仕様確認表_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD_hhmmss') + '.zip';

    this.fileDownloadConfirmService.show(data.FileName, fileName);
  }

  /**
   * 18. 企画メンテCSVファイル取込API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public uploadPlanGoodsCoopFileServiceSuccessFunc(data: any): void {
    // 処理ログを表示させる
    this.updateResult(data, KYMW0D00DataDiv.DATA_DIV_KYMW1300_PLAN_GOODS_COPE);
  }

  /**
   * 19. セット企画リスト出力API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public outputSetPlanListServiceSuccessFunc(data: any): void {
    // ファイル名の設定
    const fileName = 'セット企画_' + PlessViewUtilsSub.formatedNowDate('YYYYMMDD') + '.CSV';

    // ファイルダウンロード
    this.fileDownloadConfirmService.show(data.FileName, fileName);
  }

  /**
   * 20. 取扱生協CSVファイル取込API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public uploadCoopFileServiceSuccessFunc(data: any): void {
    // 処理ログを表示させる
    this.updateResult(data, KYMW0D00DataDiv.DATA_DIV_KYMW1300_COOP);
  }

  /**
   * 21. 企画書シート（キャロット）取込API成功処理
   *
   * @param {*} data APIレスポンス
   * @memberof KYMW1300Component
   */
  public uploadProposalCarrotFileServiceSuccessFunc(data: any): void {
    // 処理ログを表示させる
    this.updateResult(data, KYMW0D00DataDiv.DATA_DIV_KYMW1300_PROPOSALCARROT);
  }

  /**
   * 選定処理確認メッセージ表示
   *
   * @private
   * @param {KYMW1300RegistPlanModel} [registPlanVO=null] 商品選定リクエスト用VO
   * @param {Array<any>} [errList=null] エラーリスト
   * @memberof KYMW1300Component
   */
  private showErrMesRegistPlan(registPlanVO: KYMW1300RegistPlanModel = null, errList: Array<any> = null): void {
    // 入力パラメータの商品選定リクエスト用VOのチェック
    if (registPlanVO !== null) {                                                // 指定ありの場合
      this.kymw1300Model.registPlanVO = registPlanVO;
    }

    // 入力パラメータのエラーリストのチェック
    if (errList !== null) {                                                     // 指定ありの場合
      this.kymw1300Model.errList = errList;
    }

    // エラーリストのチェック
    if (this.kymw1300Model.errList == null ||                                     // エラーなしの場合
      this.kymw1300Model.errList.length < 1) {

      // 08. 商品選定リクエスト用VOのチェック
      if (this.kymw1300Model.registPlanVO.pCodeList != null &&                  // 指定ありの場合
        this.kymw1300Model.registPlanVO.pCodeList.length > 0) {

        // 08. 商品選定API呼び出し
        this.registPlanService.execute(this.kymw1300Model, this.kymw1300Model.registPlanVO,
          (data: any) => this.registPlanServiceSuccessFunc(data));
      }

    } else {
      let replaceArray: Array<string> = new Array<string>();

      // エラー情報の取得
      const errData: any = this.kymw1300Model.errList[0];

      // エラーIDのチェック
      if (errData.ErrorID === '1') {                                         // 「1:重複エラー」の場合
        replaceArray = new Array<string>();
        replaceArray.push(errData.Parameter1);
        replaceArray.push(errData.Parameter2);
        replaceArray.push(errData.Parameter3);

        // エラーメッセージ表示
        this.dialogService.openAlertGetMessage(errData.MessageID, replaceArray,
          (closeDetail: number) => this.eventRegistConfirm_CLICKHandler(closeDetail));
      } else if (errData.ErrorID === '2') {                                  // 「2:他ユーザーロック」の場合
        replaceArray = new Array<string>();
        replaceArray.push(errData.Parameter1);
        replaceArray.push(errData.Parameter2);

        // エラーメッセージ表示
        this.dialogService.openAlertGetMessage(errData.MessageID, replaceArray,
          (closeDetail: number) => this.eventLockConfirm_CLICKHandler(closeDetail));
      } else if (errData.ErrorID === '3') {                                  // 「3：翌々週配達商品」の場合
        replaceArray = new Array<string>();
        replaceArray.push(errData.Parameter1);

        // エラーメッセージ表示
        this.dialogService.openAlertGetMessage(errData.MessageID, replaceArray,
          (closeDetail: number) => this.eventTwoWeeksDelivGoodsConfirm_CLICKHandler(closeDetail));
      }
    }
  }

  /**
   * 商品選定処理・確認メッセージ(選定確認)_ボタンクリック時の処理
   *
   * @private
   * @param {number} detail 押下ボタン(PlessAlert)
   * @memberof KYMW1300Component
   */
  public eventRegistConfirm_CLICKHandler(detail: number) {
    // 「はい」以外の場合、該当Ｐコードを対象リストから除外する
    if (detail !== PlessAlert.Yes) {

      // 該当Ｐコードを対象リストから除外する
      for (let index = Number(0); index < this.kymw1300Model.registPlanVO.pCodeList.length; index++) {

        // Ｐコードの比較
        if (this.kymw1300Model.registPlanVO.pCodeList[index] === this.kymw1300Model.errList[0].PCode) {
          // 該当Ｐコードを対象リストから除外する
          this.kymw1300Model.registPlanVO.pCodeList.splice(index, 1);

          // ループ中断
          break;
        }
      }
    }

    // 処理したエラーをリストから除外する
    this.kymw1300Model.errList.splice(0, 1);

    // 残りのエラーリストを処理する(再帰処理)
    this.showErrMesRegistPlan();
  }

  /**
   * 商品選定処理・確認メッセージ(排他チェック)_ボタンクリック時の処理
   *
   * @private
   * @param {number} detail 押下ボタン(PlessAlert)
   * @memberof KYMW1300Component
   */
  public eventLockConfirm_CLICKHandler(detail: number) {
    // OK以外の場合、該当Ｐコードを対象リストから除外する
    if (detail !== PlessAlert.Yes) {
      for (let index = Number(0); index < this.kymw1300Model.registPlanVO.pCodeList.length; index++) {
        // Ｐコードの比較
        if (this.kymw1300Model.registPlanVO.pCodeList[index] === this.kymw1300Model.errList[0].PCode) {
          // 該当Ｐコードを対象リストから除外する
          this.kymw1300Model.registPlanVO.pCodeList.splice(index, 1);

          // 処理したエラーをリストから除外する
          this.kymw1300Model.errList.splice(0, 1);

          // 残りのエラーリストを処理する(再帰処理)
          this.showErrMesRegistPlan();

          // 処理復帰
          return;
        }
      }
    }

    if (PlessViewUtilsSub.isEmpty(this.kymw1300Model.errList[0].MessageID)) {
      this.kymw1300Model.errList.splice(0, 1);
      this.showErrMesRegistPlan();
    } else {
      const replaceArray: Array<string> = new Array<string>();
      replaceArray.push(this.kymw1300Model.errList[0].Parameter1);
      replaceArray.push(this.kymw1300Model.errList[0].Parameter2);

      // エラーメッセージ表示
      this.dialogService.openAlertGetMessage(this.kymw1300Model.errList[0].MessageID, replaceArray,
        (closeDetail: number) => this.eventRegistConfirm_CLICKHandler(closeDetail));
    }
  }

  /**
   * 商品選定処理・確認メッセージ(翌々週商品確認)_ボタンクリック時の処理
   *
   * @private
   * @param {number} detail 押下ボタン(PlessAlert)
   * @memberof KYMW1300Component
   */
  public eventTwoWeeksDelivGoodsConfirm_CLICKHandler(detail: number) {
    // 押下ボタンのチェック
    if (detail === PlessAlert.Yes) {                                             // 「はい」ボタンの場合
      // 選定処理を続行

      // 処理したエラーをリストから除外する
      this.kymw1300Model.errList.splice(0, 1);
    } else {                                                                    // 「はい」ボタン以外の場合
      // 選定処理を中断

      // 選定対象Ｐコードリストをクリア
      this.kymw1300Model.registPlanVO.pCodeList = new Array<string>();

      // エラーリストをクリアする
      this.kymw1300Model.errList = new Array<any>();
    }

    // 残りのエラーリストを処理する
    this.showErrMesRegistPlan();
  }

  /**
   * 選定解除処理確認メッセージ表示
   *
   * @private
   * @param {KYMW1300DeletePlanModel} [deletePlanVO=null] 選定解除リクエスト用VO
   * @param {Array<any>} [errList=null] エラーリスト
   * @memberof KYMW1300Component
   */
  private showErrMesDeletePlan(deletePlanVO: KYMW1300DeletePlanModel = null, errList: Array<any> = null): void {
    // 入力パラメータの商品解除リクエスト用VOのチェック
    if (deletePlanVO !== null) {                                                // 指定ありの場合
      this.kymw1300Model.deletePlanVO = deletePlanVO;
    }

    // 入力パラメータのエラーリストのチェック
    if (errList !== null) {                                                     // 指定ありの場合
      this.kymw1300Model.errList = errList;
    }

    // エラーリストのチェック
    if (this.kymw1300Model.errList !== null) {                                  // エラーありの場合
      while (this.kymw1300Model.errList.length > 0) {

        // エラー情報の取得
        const errData: any = this.kymw1300Model.errList[0];

        // エラーIDのチェック
        if (errData.MessageID === 'SKIP') {                                    // 代表商品も選択されている紐付商品の場合
          // 該当Ｐコードを対象リストから除外する
          for (let index = Number(0); index < this.kymw1300Model.deletePlanVO.pCodeList.length; index++) {
            // Ｐコードの比較
            if (this.kymw1300Model.deletePlanVO.pCodeList[index] === this.kymw1300Model.errList[0].PCode) {
              // 該当Ｐコードを対象リストから除外する
              this.kymw1300Model.deletePlanVO.pCodeList.splice(index, 1);

              // ループ中断
              break;
            }
          }

          // 処理したエラーをリストから除外する
          this.kymw1300Model.errList.splice(0, 1);

          // 次データ読込
          continue;
        }

        let replaceArray: Array<string> = new Array<string>();
        replaceArray = new Array<string>();
        replaceArray.push(errData.Parameter1);
        replaceArray.push(errData.Parameter2);
        replaceArray.push(errData.Parameter3);
        replaceArray.push(errData.Parameter4);
        replaceArray.push(errData.Parameter5);

        // エラーメッセージ表示
        this.dialogService.openAlertGetMessage(errData.MessageID, replaceArray,
          (closeDetail: number) => this.eventDeleteConfirm_CLICKHandler(closeDetail));

        // 処理復帰
        return;
      }
    }

    // 選定解除リクエスト用VOのチェック
    if (this.kymw1300Model.deletePlanVO.pCodeList != null                       // 指定ありの場合
      && this.kymw1300Model.deletePlanVO.pCodeList.length > 0) {

      // 10. 選定解除API呼び出し
      this.deletePlanService.execute(this.kymw1300Model, this.kymw1300Model.deletePlanVO,
        (data: any) => this.deletePlanServiceSuccessFunc(data));
    }
  }

  /**
   * 選定解除処理・確認メッセージ_ボタンクリック時の処理
   *
   * @private
   * @param {number} detail 押下ボタン(PlessAlert)
   * @memberof KYMW1300Component
   */
  public eventDeleteConfirm_CLICKHandler(detail: number) {
    // Yes以外の場合、該当Ｐコードを対象リストから除外する
    if (detail !== PlessAlert.Yes) {

      // 該当Ｐコードを対象リストから除外する
      for (let index = Number(0); index < this.kymw1300Model.deletePlanVO.pCodeList.length; index++) {

        // Ｐコードの比較
        if (this.kymw1300Model.deletePlanVO.pCodeList[index] === this.kymw1300Model.errList[0].PCode) {

          // 該当Ｐコードを対象リストから除外する
          this.kymw1300Model.deletePlanVO.pCodeList.splice(index, 1);

          // ループ中断
          break;
        }
      }
    }

    // 処理したエラーをリストから除外する
    this.kymw1300Model.errList.splice(0, 1);

    // 残りのエラーリストを処理する(再帰処理)
    this.showErrMesDeletePlan();
  }



  /**
   * Pコード一発選定(メインメニュー)の活性制御を行う
   *
   * @returns {boolean} 活性制御(true：活性、false：非活性)
   * @memberof KYMW1300Component
   */
  public setEnabledKYMW1304(): boolean {
    // 編集ロック、媒体区分、売り場区分のチェック
    if (this.getIcnEditLock()                                                           // 「true：編集」、
      && !PlessViewUtilsSub.isEmpty(this.kymw1300Model.mediumType)                      // 媒体区分が選択あり、
      && !PlessViewUtilsSub.isEmpty(this.cmb_SellArea.selectedSellAreaCode)             // 売り場区分が選択あり、
      && this.getFuncPermission() === this.kymw00Model.FUNC_PERMISSION_FULLCONTROL
    ) {   // 権限が「2：フルコントロール可能」の場合
      return true;
    } else {                                                                    // 上記以外の場合
      return false;
    }
  }

  /**
   * セット企画リスト出力(メインメニュー)、セット企画設定(メインメニュー)の活性制御を行う
   *
   * @returns {boolean} 活性制御(true：活性、false：非活性)
   * @memberof KYMW1300Component
   */
  public setEnabledSetPlanMenu(): boolean {
    if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.orderCode)) {
      // 受注コードのチェック
      return this.txt_OrderCode.isValidOrderCode()
    } else if (!PlessViewUtilsSub.isEmpty(this.kymw1300Model.startOrderCode)) {
      // 束ね企画回開始受注コードのチェック
      return this.isValidStartOrderCode()
    }
  }

  // サブ画面再表示 START

  /**
   * 子画面再表示処理
   *
   * @param {string} target 画面ID
   * @param {boolean} editLock 編集ロック
   * @memberof KYMW1300Component
   */
  public refleshChildWindow(target: string, editLock: boolean): void {
    // 『実績履歴』画面再表示
    if (PlessViewUtilsSub.isEmpty(target)                                       // 指定なし、
      || target === 'KYMW0800') {                                                // 「KYMW0800：実績履歴画面」の場合
      // 実績履歴画面の起動状況のチェック
      if (this.isOpened('KYMW0800')) {                                          // 起動済みの場合
        const kymw0800vo: KYMW0800InputModel = this.kymw1300Model.setKYMW0800InputVO(this.kymw1300Model.currentContext);

        if (!editLock) {
          kymw0800vo.funcID = 'KYMW1300L';
        }

        this.kymw0800cmp.setInputVO(kymw0800vo);
      }
    }

    // 『Ｗ掲載設定』画面再表示
    if (PlessViewUtilsSub.isEmpty(target)                                       // 指定なし、
      || target === 'KYMW1310') {                                                // 「KYMW1310：Ｗ掲載設定画面」の場合
      // Ｗ掲載設定画面の起動状況のチェック
      if (this.isOpened('KYMW1310')) {                                          // 起動済みの場合

        // 媒体区分のチェック
        if (!this.kymw1300Model.isDutiesFormWeekly()) {                         // 「ウィークリーでない」の場合
          // Ｗ掲載設定画面を閉じる
          this.kymw1310cmp.onClickWindowClose();
          this.kymw1310cmp = null;
        } else {                                                                // 「ウィークリーである」の場合
          const kymw1310vo: KYMW1310InputModel = this.kymw1300Model.setKYMW1310InputVO();
          kymw1310vo.editLock = editLock;
          this.kymw1310cmp.setInterfaceParam(kymw1310vo);
          this.kymw1310cmp.setInputVO(kymw1310vo);
        }
      }
    }
  }

  // サブ画面再表示 END

  /**
   * ロック状態取得
   *
   * @returns {boolean} ロック状態(true：編集、false：閲覧)
   * @memberof KYMW1300Component
   */
  public getIcnEditLock(): boolean {
    if (this.clsLock === this.BUTTON_STYLE_SELECTED) {
      return true;
    } else {
      return false;
    }
  }


  // ロード完了通知 START
  /**
   *  売り場コードコンボロード完了通知
   *
   * @param {string} code 選択売り場コード
   * @memberof KYMW1300Component
   */
  public sellAreaCodeLoadCompleted(code: string): void {
    this.kymw1300Model.sellAreaCode = code;
  }

  // ロード完了通知 END

  /**
   * 画面終了時処理
   *
   * @memberof KYMW1300Component
   */
  canDeactivate(): CanDeactivateType {
    // 終了時、各子画面が開いていれば終了する。

    // 実績履歴画面
    if (this.isOpened('KYMW0800')) {
      this.kymw0800cmp.eventClose_ClickHandler(null);
    }

    // 予算・計画・実績表画面
    if (this.isOpened('KYMW1307')) {
      this.kymw1307cmp.onClickWindowClose();
    }

    // バンドルミックスマッチ設定画面
    if (this.isOpened('KYMW1308')) {
      this.kymw1308cmp.eventClose_CLICKHandler(null);
    }

    // Ｗ掲載設定画面
    if (this.isOpened('KYMW1310')) {
      this.kymw1310cmp.onClickWindowClose();
    }

    // セット企画画面
    if (this.isOpened('KYMW1312')) {
      // ロック情報リリース
      this.kymw1312cmp.releaseLock();

      // 編集が行われている場合、メッセージを表示
      if (this.kymw1312cmp.editCount > 0) {
        const result = new Subject<boolean>();
        this.dialogService.openAlertGetMessage('Q0107', ['セット企画プロモーション情報'],
          (closeDetail: number) => {
            if (closeDetail === PlessAlert.Yes) {
              this.kymw1312cmp.closeFunction();
              result.next(true);
            } else {
              result.next(false);
            }
        });
        return result;
      }
    }

    // 自画面を終了
    return true;
  }

  /**
   * バンドルミックスマッチボタンの活性制御
   *
   * @memberof KYMW1300Component
   */
  public changeEnableBundleMixMatch() {
    // 受注コードと束ね企画回の開始受注コードのいずれも無効の場合は非活性
    if (!this.txt_OrderCode.isValidOrderCode() && PlessViewUtilsSub.isEmpty(this.kymw1300Model.startOrderCode)) {
      this.plessEnabled(this.kymw1300_03.btn_bundleMixMatch, false);
      return;
    }

    // 媒体コンボボックスの選択媒体の業態区分がウィークリー媒体（1：ウィークリー）以外の場合は非活性
    if (PlessViewUtilsSub.isEmpty(this.kymw1300Model.mediumType) || !this.kymw1300Model.isDutiesFormWeekly()) {
      this.plessEnabled(this.kymw1300_03.btn_bundleMixMatch, false);
      return;
    }

    this.plessEnabled(this.kymw1300_03.btn_bundleMixMatch, true);
  }
}
